const defaultSpanishMessages = {
  date: {
    defaultDateFormat: "dd.MM.yyyy",
    defaultDateTimeFormat: "dd.MM.yyyy kk:mm:ss",
    dateInputPattern: "##.##.####",
  },
  ra: {
    action: {
      add_filter: "Agregar filtro",
      add_price_position: "Agregar posición",
      add: "Agregar",
      accept: "Aceptar",
      back: "Atrás",
      bulk_actions: "Un elemento seleccionado |||| %{smart_count} elementos seleccionados",
      cancel: "Cancelar",
      clear_input_value: "Borrar entrada",
      clear_array_input: "Borrar entrada de lista",
      clone: "Clonar",
      close: "Cerrar",
      close_menu: "Cerrar menú",
      confirm: "Confirmar",
      create: "Crear",
      create_item: "Crear entrada",
      delete: "Eliminar",
      download: "Descargar",
      edit: "Editar",
      expand: "Expandir",
      export: "Exportar",
      list: "Lista",
      move_down: "Mover hacia abajo",
      move_up: "Mover hacia arriba",
      open: "Abrir",
      open_menu: "Abrir menú",
      reset: "Reset",
      refresh: "Actualizar",
      remove_filter: "Eliminar filtro",
      remove_all_filters: "Eliminar todos los filtros",
      remove: "Eliminar",
      save: "Guardar",
      search: "Buscar",
      search_columns: "Buscar en columnas",
      select_all: "Seleccionar todo",
      select_all_button: "Seleccionar todo",
      select_row: "Seleccionar entrada",
      select_columns: "Columnas",
      send: "Enviar",
      show: "Mostrar",
      sort: "Ordenar",
      toggle_theme: "Cambiar tema",
      undo: "Deshacer",
      unselect: "Deseleccionar",
      update: "Actualizar",
      update_application: "Actualizar aplicación",
    },
    boolean: {
      true: "Sí",
      false: "No",
      null: " ",
    },
    page: {
      list: "%{name}",
      edit: "%{name} #%{id}",
      show: "%{name} #%{id}",
      create: "Crear %{name}",
      loading: "Cargando",
      dashboard: "Panel",
      not_found: "No encontrado",
      error: "Algo salió mal",
      empty: "Aún no hay nada aquí.",
      invite: "¿Quieres cambiar algo?",
      access_denied: "Acceso denegado",
      authentication_error: "Error de autenticación",
    },
    sort: {
      ASC: "ascendente",
      DESC: "descendente",
      sort_by: "%{field}",
    },
    input: {
      file: {
        upload_several: "Arrastra los archivos para subirlos o haz clic aquí para seleccionarlos.",
        upload_single: "Arrastra el archivo para subirlo o haz clic aquí para seleccionarlo.",
      },
      image: {
        upload_several: "Arrastra las imágenes para subirlas o haz clic aquí para seleccionarlas.",
        upload_single: "Arrastra la imagen para subirla o haz clic aquí para seleccionarla.",
      },
      password: {
        toggle_visible: "Ocultar contraseña",
        toggle_hidden: "Mostrar contraseña",
      },
      references: {
        all_missing: "No se pudieron encontrar las referencias asociadas.",
        many_missing: "Al menos una de las referencias asociadas parece no estar disponible.",
        single_missing: "Una referencia asociada parece no estar disponible.",
      },
    },
    message: {
      yes: "Sí",
      no: "No",
      are_you_sure: "¿Estás seguro?",
      about: "Acerca de",
      auth_error: "Por favor, inicia sesión para continuar",
      not_found: "No se pudo encontrar la página.",
      loading: "La página se está cargando.",
      invalid_form: "El formulario no es válido. Por favor, revise sus entradas.",
      delete_title: "Eliminar",
      delete_content: "¿Realmente desea eliminar este contenido?",
      bulk_delete_title: "Confirmar eliminación",
      bulk_delete_content:
        "¿Realmente desea eliminar este elemento? |||| ¿Realmente desea eliminar estos %{smart_count} elementos?",
      bulk_update_content:
        "¿Realmente desea actualizar este elemento? |||| ¿Realmente actualizar estos %{smart_count} elementos?",
      bulk_update_title: "Confirmar actualización",
      clear_array_input: "¿Realmente desea eliminar toda la lista?",
      details: "Detalles",
      error: "Ocurrió un error y su solicitud no pudo completarse.",
      unsaved_changes: "Algunos cambios no se han guardado. ¿Realmente ignorar?",
      delete_failed_must_archive: "No es posible eliminar, por favor archive.",
      access_denied: "Acceso denegado",
      authentication_error: "Error de autenticación",
      select_all_limit_reached: "Se alcanzó el número máximo de selección",
      placeholder_data_warning: "Problema de red: error al actualizar los datos.",
    },
    navigation: {
      no_results: "Aún no hay disponible",
      no_more_results: "La página %{page} no contiene contenido.",
      page_out_of_boundaries: "La página %{page} está fuera del rango válido",
      page_out_from_end: "Última página",
      page_out_from_begin: "Primera página",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      page_rows_per_page: "Filas por página:",
      next: "Siguiente",
      prev: "Atrás",
      previous: "Atrás",
      skip_nav: "Ir al contenido",
      partial_page_range_info: "%{offsetBegin}-%{offsetEnd} de más de %{offsetEnd}",
      current_page: "Página %{page}",
      page: "Página %{page}",
      first: "Primera página",
      last: "Última página",
      no_filtered_results: "No se encontraron resultados para estos filtros.",
      clear_filters: "Restablecer todos los filtros",
    },
    auth: {
      auth_check_error: "Por favor inicie sesión para continuar",
      user_menu: "Perfil",
      username: "Correo electrónico",
      email: "Correo electrónico",
      password: "Contraseña",
      sign_in: "Iniciar sesión",
      sign_in_error: "Error al iniciar sesión",
      logout: "Cerrar sesión",
    },
    notification: {
      i18n_error: "Traducciones para el idioma seleccionado no disponibles.",
      not_authorized: "No tiene acceso a este contenido.",
      updated: "Elemento actualizado |||| %{smart_count} elementos actualizados",
      created: "Elemento creado",
      deleted: "Elemento eliminado |||| %{smart_count} elementos eliminados",
      bad_item: "Elemento defectuoso",
      item_doesnt_exist: "El elemento no existe",
      http_error: "Error al comunicarse con el servidor",
      data_provider_error: "Error de dataProvider. Verifica la consola para más detalles.",
      canceled: "Acción cancelada",
      logged_out: "Has sido desconectado. Por favor, inicia sesión nuevamente.",
      application_update_available: "Actualización disponible",
      offline: "Offline",
    },
    validation: {
      required: "Requerido",
      minLength: "Debe tener al menos %{min} caracteres",
      maxLength: "No puede tener más de %{max} caracteres",
      minValue: "Debe ser al menos %{min}",
      maxValue: "Debe ser %{max} o menos",
      number: "Debe ser un número",
      email: "Debe ser un correo electrónico válido",
      oneOf: "Debe ser uno de: %{options}",
      regex: "Debe coincidir con la expresión regular: %{pattern}",
      not_unique: "ya está en uso",
      unique: "Debe ser único",
    },
    saved_queries: {
      label: "Filtros guardados",
      query_name: "Nombre del filtro",
      new_label: "Guardar filtro actual...",
      new_dialog_title: "Guardar filtro actual como",
      remove_label: "Eliminar filtro guardado",
      remove_label_with_name: 'Eliminar filtro guardado "%{name}"',
      remove_dialog_title: "¿Eliminar filtro guardado?",
      remove_message: "¿Deseas eliminar esta entrada de tu lista de filtros guardados?",
      help: "Filtrar lista y guardar configuración del filtro",
    },
    configurable: {
      customize: "Personalizar",
      templateError: "## Error de plantilla",
      configureMode: "Configurar esta página",
      inspector: {
        title: "Inspector",
        content: "Señala los elementos de la aplicación para personalizarlos",
        reset: "Restablecer configuraciones",
        hideAll: "Ocultar todo",
        showAll: "Mostrar todo",
      },
      SimpleList: {
        title: "Lista",
        primaryText: "Texto primario",
        secondaryText: "Texto secundario",
        tertiaryText: "Texto terciario",
      },
      Datagrid: {
        title: "Cuadro de datos",
        unlabeled: "Columna sin nombre #%{column}",
      },
      SimpleForm: {
        title: "Formulario",
        unlabeled: "Campo sin nombre #%{input}",
      },
    },
  },
};

const userFields = {
  id: "ID",
  image_path: "Ruta de la imagen",
  lecturer_fee: "Remuneración",
  user_custom_fields_data: "Campos avanzados",
  is_unverified: "Sin verificar",
  guest: "Invitado",
  title: "Título",
  first_name: "Nombre",
  last_name: "Apellido",
  full_name: "Nombre completo",
  gender: "Género",
  birthday: "Fecha de nacimiento",
  address: "Dirección",
  main_contact_info: "Comunicación",
  invoice_contact_info: "Factura",
  invoice_dispatch_contact_info: "Envío de factura",
  main_contact_info__email: "Correo electrónico (Comunicación)",
  main_contact_info__organization_name: "Nombre de la organización (Comunicación)",
  main_contact_info__city: "Ciudad (Comunicación)",
  main_contact_info__postcode: "Código postal (Comunicación)",
  login_email: "Correo electrónico de inicio de sesión",
  auth_user__email: "Correo electrónico de inicio de sesión",
  lecturer__common_fee: "Remuneración (€)",
  attendee__attendee_number: "Número de cliente",
  contact_types: "Tipos de información de contacto",
  debit_number: "Número de deudor",
  audience_role: "Público objetivo",
  common_fee: "Remuneración (€)",
  description: "Descripción",
  qualifications: "Cualificaciones",
  categories: "Categorías",
  image: "Imagen",
  documents: "Documentos",
  created_at: "Creado",
  contact_info: {
    id: "ID",
    email: "Correo electrónico",
    phone: "Teléfono",
    mobile: "Móvil",
    fax: "Fax",
    website: "Sitio web",
    organization_name: "Nombre de la organización",
    address_line_1: "Línea de dirección 1",
    address_line_2: "Línea de dirección 2",
    co: "c/o",
    postcode: "Código postal",
    countrycode: "Código de país",
    city: "Ciudad",
    state: "Estado",
    country: "País",
  },
  tags: "Palabras clave",
  language: "Idioma",
  lists: "Listas suscritas",
  accounts: "Cuentas",
  organization_names: "Organizaciones asignadas",
};
const userAndEnrollmentFilters = {
  emails: "Correos electrónicos",
  qualifications: "Calificaciones",
  categories: "Categorías",
  event_base_categories: "Categorías de ofertas",
};
const customFieldContentTypeName = "Campo avanzado |||| Campos avanzados";
const spanishMessages = {
  ...defaultSpanishMessages,
  resources: {
    applications: {
      name: "Aplicación OAuth |||| Aplicaciones OAuth",
    },
    event_attendances: {
      name: "Asistencia |||| Asistencias",
      fields: {
        comment: "Comentario",
        has_attended: "Asistió",
      },
      actions: {
        add_absence: "Agregar ausencia",
        edit_absence: "Editar ausencia",
        add_comment: "Agregar comentario",
        edit_comment: "Editar comentario",
        mark_attended: "Marcar como asistido",
        mark_unattended: "Marcar como no asistido",
      },
      hints: {
        has_attended: "Participó",
        has_not_attended: "No ha asistido",
        has_attended_count: "Participado en %{attendedCount} de %{attendedMax} sub-eventos",
        attendance_unknown: "Participación desconocida",
      },
    },
    attendance_absences: {
      name: "Ausencia |||| Ausencias",
      fields: {
        absence_start: "Inicio de la ausencia",
        absence_end: "Fin de la ausencia",
      },
      validation: {
        start_time_before: "El inicio de la ausencia debe ser antes de %{maxTime}",
        start_time_after: "El inicio de la ausencia debe ser después de %{minTime}",
        end_time_after: "El fin de la ausencia debe ser antes de %{maxTime}",
        start_time_before_end_time: "El inicio de la ausencia debe ser antes del fin de la ausencia",
        end_time_after_start_time: "El fin de la ausencia debe ser después del inicio de la ausencia",
      },
    },
    attendees: {
      name: "Participante |||| Participantes",
      fields: { ...userFields, with: "Participante", attendee_number: "Número de cliente" },
      actions: {
        update_contact_infos: "Actualizar información de contacto",
        add_main_contact_info: "Comunicación",
        add_invoice_contact_info: "Factura",
        add_invoice_dispatch_contact_info: "Envío de facturas",
        enroll_to_moodle_courses: "Inscribirse en curso(s) de Moodle",
        add_new_interested: "Crear nuevo interesado",
        add_new: "Crear nueva persona",
        add_existing: "Personas existentes",
        copy_main_contact_info: "Usar dirección de comunicación",
        show_more_fields: "Mostrar más campos",
        add_to_list: "Añadir a la lista",
        add_to_organization: "Añadir a organización",
      },
      hints: {
        booking_documents_at_booking: "Los documentos de reserva se pueden encontrar en la reserva correspondiente.",
        debit_number_taken:
          "ya está siendo utilizado por otra persona u organización. Asegúrese de que es lo que desea.",
        debit_number_outside_range:
          "El número de deudor %{debit_number} está fuera del rango de números de deudor %{range}.",
        debit_number_range_open: "desde %{start}",
      },
      is_archived: "El participante está archivado",
      removed: "La persona está eliminada",
    },
    audiences: {
      name: "Público objetivo |||| Públicos objetivos",
      fields: {
        name: "Nombre",
      },
    },
    auth_groups: {
      name: "Grupo de permisos |||| Grupos de permisos",
    },
    customer: {
      name: "Perfil del cliente |||| Perfil del cliente",
      fields: {
        name: "Nombre",
        value_added_tax_id: "Número de identificación fiscal",
        trade_register_number: "Número de registro mercantil",
        fiscal_number: "Número fiscal",
        iban: "IBAN",
      },
      hints: {
        no_customer_created_yet: "Aún no se ha creado ningún perfil de cliente.",
      },
      sections: {
        general: "General",
        invoicing: "Facturación",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
    },
    contact_persons: {
      name: "Persona de contacto |||| Personas de contacto",
    },
    user_roles: {
      name: "Grupo de permisos |||| Grupos de permisos",
      fields: {
        name: "Nombre",
        permission_groups: "Permisos",
      },
      auth_groups: {
        default: "Acceso a la interfaz",
        manage_events: "Gestionar eventos",
        manage_event_bases: "Gestionar ofertas",
        manage_orders: "Gestionar pedidos",
        manage_users: "Gestionar usuarios",
        manage_attendees: "Gestionar participantes",
        manage_interests: "Gestionar interesados",
        manage_lecturers: "Gestionar docentes",
        manage_todos_and_responsibilities: "Gestionar tareas y responsabilidades",
        manage_bookings: "Gestionar reservas",
        manage_moodle: "Gestionar Moodle",
        manage_invoices: "Gestionar facturas",
        manage_access: "Gestionar acceso EDM",
        manage_templates: "Gestionar plantillas",
        manage_settings: "Gestionar configuraciones",
        manage_base_data: "Gestionar datos maestros",
        manage_organizations: "Gestionar organizaciones",
        view_accounting: "Ver facturación EDM",
        view_reporting: "Ver evaluación",
        view_booking_list: "Ver lista de reservas",
        view_invoice_list: "Ver lista de facturas",
        manage_accounting: "Contabilidad",
        manage_event_feedback: "Gestionar comentarios de eventos",
        view_feedback_report: "Ver evaluación de comentarios",
        attendee: "Autorizaciones para participantes",
        lecturer: "Autorizaciones para conferenciantes",
      },
      headlines: {
        permission_info: "Descripción de los permisos",
      },
    },
    auth_users: {
      name: "Iniciar sesión",
      fields: {
        email: "Correo electrónico",
      },
    },
    bookings: {
      name: "Reserva |||| Reservas",
      fields: {
        event_date_attendances: "Asistencia",
        has_attended: "Asistió",
        price_positions: "Posiciones de precio",
        attendee: "Participante",
        booking_number: "Número de reserva",
        status: "Estado",
        created_at: "Registrado el",
        format: "Formato de participación",
        first_name: "Nombre",
        last_name: "Apellido",
        event: "Evento",
        event_id_number: "Número de evento",
        amount: "Monto",
        price: "Precio",
        invoices: "Factura",
        invoiced_amount: "Facturado",
        price_amount: "Monto",
        price_name: "Nombre del precio",
        attendee__last_name: "Apellido",
        price__price_type__name: "Tipo de precio",
        order_item__order__order_number: "Número de pedido",
        order: "Pedido",
      },
      calculated_fields: {
        paid: "pagado",
        attended: "Asistido",
      },
      actions: {
        cancel_order_item: "Cancelar la posición del pedido |||| Cancelar las posiciones del pedido",
        cancel_bookings: "Cancelar reserva |||| Cancelar reservas",
        cancel_bookings_count: "Cancelar reserva |||| Cancelar %{smart_count} reservas",
        invoices_menu: "Factura",
        change_status: "Cambiar estado",
        create_invoices: "Crear factura |||| Crear facturas",
        download_invoices: "Descargar factura |||| Descargar facturas",
        send_invoices: "Enviar factura |||| Enviar facturas",
        delete_invoices: "Eliminar factura |||| Eliminar facturas",
        edit_invoices: "Editar factura |||| Editar facturas",
        send_mail_to_all_bookings: "Correo electrónico a todos",
        send_mail_to_all_bookings_VALID: "%{bookingCount} participantes inscritos",
        send_mail_to_all_bookings_WAITING: "%{bookingCount} participantes en espera",
        send_mail_to_all_bookings_CANCELED: "%{bookingCount} participantes cancelados",
        send_mail_to_all_lecturers: "%{lecturerCount} docentes",
        edit_attendance: "Editar asistencia",
        mark_as_attended: "Marcar como asistido",
        mark_as_unattended: "Marcar como no asistido",
        add_as_interests: "Agregar como interesado",
        alter_bookings: "Reagendar",
        use_existing_price_type: "Usar el mismo tipo de precio",
        create_correction_invoice: "Crear factura rectificativa para la posición cancelada",
        use_custom_fields_data: "Aplicar campos de reserva avanzados",
        visit_website: "Visitar sitio web",
        bill_to_other: "Asignar el pedido a una organización / otra persona",
        delete: "Eliminar reserva |||| Eliminar reservas",
      },
      hints: {
        billing_unchanged:
          "La posición del pedido existente se asigna al nuevo evento. El precio, los pagos y las facturas no cambian. Las facturas ya emitidas siguen mostrando el evento anterior.",
        rebill:
          "La posición del pedido anterior se cancela y se sustituye en el mismo pedido por una nueva posición con el precio seleccionado abajo. Los importes ya pagados no se transfieren a la nueva posición. Para las posiciones ya facturadas se puede crear una factura rectificativa. Si es necesario, la factura de la nueva posición se crea manualmente.",
        rebill_prepaid: "No es posible en pedidos con pago por adelantado; cread un pedido aparte.",
        order_item_stays_active:
          "La posición del pedido sigue activa, cuenta como vendida y sigue pendiente de facturación. Solo quien puede gestionar pedidos puede cancelarla. |||| Las posiciones del pedido siguen activas, cuentan como vendidas y siguen pendientes de facturación. Solo quien puede gestionar pedidos puede cancelarlas.",
        status_locked_by_canceled_item_rebooked:
          "La posición del pedido está cancelada, por lo que la reserva sigue reagendada.",
        status_locked_by_canceled_item: "La posición del pedido está cancelada, por lo que la reserva sigue cancelada.",
        skipped_canceled_items:
          "%{smart_count} reserva omitida porque su posición del pedido está cancelada |||| %{smart_count} reservas omitidas porque su posición del pedido está cancelada",
        bookings_to_cancel: "Se cancelará %{smart_count} reserva. |||| Se cancelarán %{smart_count} reservas.",
        already_canceled: "%{smart_count} reserva ya está cancelada. |||| %{smart_count} reservas ya están canceladas.",
        deleted: "Reserva eliminada |||| Reservas eliminadas",
        delete_explanation:
          "La reserva se elimina definitivamente y su posición del pedido vuelve a quedar sin procesar. |||| Las reservas se eliminan definitivamente y sus posiciones del pedido vuelven a quedar sin procesar.",
        bill_to_other:
          "Por defecto: un pedido independiente por persona. Actívalo para agrupar a todos los participantes en un solo pedido facturado a una organización u otra persona.",
        override_validation: "Omitir las comprobaciones de disponibilidad (capacidad, etc.) y permitir el sobrecupo.",
      },
      tooltips: {
        has_attended_event: "ha asistido al evento",
        has_attended_group_events: "ha asistido a %{attendedCount} de %{attendedMax} sub-eventos",
      },
      labels: {
        created_at: "inscrito el",
        rebooked_to: "reagendado a",
        rebooked_from: "reagendado de",
        booking_data: "Datos de reserva",
        fallback_price: "Precio si falta el tipo de precio",
        billing_mode: "Posición del pedido",
        is_archived: "Esta reserva está archivada",
        no_bookings: "No hay reservas disponibles.",
      },
      billing_modes: {
        UNCHANGED: "Mantener la posición del pedido",
        REBILL: "Cancelar la posición del pedido y crear una nueva",
      },
      status: {
        VALID: "Reservado",
        CANCELED: "Cancelado",
        WAITING: "Lista de espera",
        REBOOKED: "Reservado de nuevo",
      },
    },
    categories: {
      name: "Categoría |||| Categorías",
      fields: {
        name: "Nombre",
        parent_category: "Categoría principal",
        parent_category_name: "Nombre de la categoría principal",
      },
      is_archived: "Esta categoría está archivada",
    },
    checkouts: {
      name: "Checkout |||| Checkouts",
      fields: {
        checkout_id: "ID de checkout",
        payment_id: "ID de pago",
      },
    },
    consents: {
      name: "Consentimiento |||| Consentimientos",
      fields: {
        is_confirmed: "Confirmado",
        timestamp: "Creado el",
        order_number: "Número de pedido",
        additional_info: "Información adicional",
      },
      hints: {
        confirmation_thank_you: "¡Gracias por confirmar!",
      },
    },
    consent_types: {
      name: "Tipo de consentimiento |||| Tipos de consentimiento",
      fields: {
        name: "Nombre",
        scope: "Ámbito",
        needs_confirmation: "Requiere Doble Opt-In",
        welcome_mail_template: "Plantilla de correo electrónico tras consentimiento",
        confirmation_mail_template: "Plantilla de correo de confirmación",
        redirect_url: "URL de redirección",
        description: "Descripción",
        show_in_registration_form: "Mostrar en formulario de registro",
        registration_text: "Texto del formulario de registro",
      },
    },
    contexts: {
      name: "Entorno |||| Entornos",
      fields: {
        name: "Nombre",
      },
    },
    content_types: {
      name: customFieldContentTypeName,
    },
    customer_invoices: {
      name: "Factura |||| Facturas",
      fields: {
        id: "Número de factura",
        to_datetime: "Reservas hasta",
        from_datetime: "Reservas desde",
        minimum_price_per_month: "Precio mínimo por mes",
        created_at: "Creado el",
        discount: "Descuento",
        positions: "Posiciones de reserva",
        commission_sum: "Monto de la comisión",
        commission_per_month: "Comisión fija por mes",
        invoice_sum: "Suma total",
        attendee_name: "Participante",
        booking_number: "Número de reserva",
        order_number: "Número de pedido",
        event_name: "Evento",
        booking_amount: "Monto de la reserva",
        commission: "Comisión",
        positions_count: "Cantidad de posiciones de reserva",
      },
      labels: {
        minimum_amount: "Monto mínimo",
      },
      filters: {
        negative_commission_only: "Mostrar solo montos de comisión negativos",
      },
    },
    custom_field_select_values: {
      name: "Valores de selección (Campos personalizados)",
    },
    dashboard: {
      name: "Tablero",
    },
    custom_fields_data: {
      name: customFieldContentTypeName,
      fields: {
        value: "Valor",
      },
    },
    descriptions: { name: "Descripción |||| Descripciones", fields: { id: "ID", text: "Texto", slug: "Slug" } },
    document_templates: {
      name: "Plantilla de documento |||| Plantillas de documento",
      label: "Plantilla de documento",
      templateVersions: "Versiones de plantillas",
      version: "Versión %{version}",
      input: {
        upload_version: "Subir nueva versión",
        store_permanently: "Guardar en %{scope}",
        show_custom_content: "Agregar contenido personalizado",
        hide_custom_content: "Ocultar contenido personalizado",
        custom_content: "Contenido personalizado",
      },
      actions: {
        showMoreVersions: "Mostrar todas las versiones",
        showLessVersions: "Menos",
        generate: "Crear documentos",
        save_and_close: "Guardar y cerrar",
        save_and_send: "Guardar y enviar",
        download_all: "Descargar todo",
        example_menu: "Ejemplos",
      },
      related_resource: {
        BOOKING_TEMPLATE: "Reserva",
        EVENT_TEMPLATE: "Evento",
        EVENT_BASE_TEMPLATE: "Oferta",
        ATTENDEE_TEMPLATE: "Participante",
        LECTURER_TEMPLATE: "Docente",
        INVOICE_TEMPLATE: "Factura",
        ORGANIZATION_TEMPLATE: "Organización",
        EVENT_LOCATION_TEMPLATE: "Lugar del evento",
      },
      fields: {
        original_filename: "Nombre del archivo",
        related_resource: "Contexto",
        created_at: "Creado el",
        language: "Idioma",
        parent_template: "Plantilla superior",
      },
      notification: {
        only_ms_word_files_allowed: "Tipo de archivo no válido. Los permitidos son: .docx y .doc",
        successfully_generated:
          "%{smart_count} documento fue generado exitosamente |||| %{smart_count} documentos fueron generados exitosamente",
        generation_finished: "Generación de documento finalizada |||| Generación de documentos finalizada",
        generation_in_progress: "Documento en proceso de generación |||| Documentos en proceso de generación",
        generation_other_pending:
          "%{smart_count} otro documento se genera primero |||| %{smart_count} otros documentos se generan primero",
        generation_error: "Error al generar el documento |||| Error al generar los documentos",
        persist_success: "Los documentos fueron guardados permanentemente",
        persist_error: "Error al guardar los documentos",
        no_templates_present: "No hay plantillas disponibles para esta área.",
      },
      document_types: {
        participation_certificate: "Certificado de participación",
        name_plates: "Placas de nombres",
      },
    },
    edm_moodle_enrollments: {
      name: "Inscripción en Moodle |||| Inscripciones en Moodle",
    },
    enrollments: {
      name: "Registro |||| Registros",
      fields: {
        ...userFields,
        approval_url: "Enlace de aprobación",
        approval_status: "Aprobación",
        approval_reason: "Motivo",
      },
    },
    orders: {
      name: "Pedido |||| Pedidos",
      fields: {
        id: "ID",
        status: "Estado",
        order_number: "Número de pedido",
        buyer: "Comprador/a",
        organization: "Organización",
        user: "Persona compradora",
        payment_provider: "Método de pago",
        is_paid: "Pagado",
        is_fully_invoiced: "Totalmente facturado",
        is_self_order: "Autorregistro",
        total: "Total",
        buyer_note: "Nota de la persona compradora",
        your_note: "Su nota",
        note: "Su nota",
        open_items: "Posiciones abiertas",
        item_count: "Artículos",
        events: "Eventos",
        created_at: "Creado el",
      },
      filters: {
        has_processable_items: "Pendiente de procesar",
        person: "Comprador o asistente",
        event: "Evento",
      },
      status: {
        pending: "Pendiente",
        confirmed: "Confirmado",
        canceled: "Cancelado",
      },
      payment_status: {
        pending: "Pendiente",
        failure: "Fallido",
        completed: "Completado",
      },
      checkout_failure_reason: {
        cancel_redirect: "El comprador canceló el pago. Las plazas reservadas se han liberado.",
        expired_webhook: "El plazo de pago ha expirado. Las plazas reservadas se han liberado.",
      },
      payment_provider: {
        stripe: "Tarjeta de crédito (Stripe)",
        edm_invoice: "Factura",
      },
      buyer_type: {
        user: "Persona",
        organization: "Organización",
      },
      roles: {
        buying_person: "Persona compradora",
        organization: "Organización compradora",
        attendee: "Participantes",
      },
      headlines: {
        custom_fields: "Campos personalizados",
        buyer: "Comprador/a",
        summary: "Resumen",
        cancellation_email: "Correo de cancelación",
      },
      actions: {
        edit: "Editar pedido",
        create: "Crear pedido",
        confirm: "Confirmar",
        cancel: "Cancelar",
        delete: "Eliminar pedido",
        create_invoice: "Crear factura",
        create_invoices: "Crear facturas",
        quick_book_all: "Reserva rápida de todas (%{count})",
        quick_book: "Reserva rápida de todas",
        override_validation: "Omitir comprobaciones (sobreocupar)",
        create_correction_invoice: "Crear factura rectificativa",
        create_reversal_invoice: "Crear factura de anulación",
        create_correction_and_reversal_invoices: "Crear facturas rectificativas y de anulación",
        refund: "Reembolsar el pago",
        email_buyer: "Enviar correo al comprador",
        email_attendees: "Enviar correo a participantes",
        email_buyers: "Enviar correo a compradores",
        email_attendees_disabled:
          "Ninguna de las posiciones seleccionadas tiene una reserva: no hay participantes a quienes escribir.",
        resume_checkout: "Pagar ahora",
      },
      hints: {
        invoice_canceled_order:
          "El pedido está cancelado. Solo se pueden facturar posiciones personalizadas, p. ej. una tasa de cancelación.",
        ordered_at_by: "pedido el %{date} por",
        ordered_at: "del %{date}",
        confirmed: "Pedido confirmado",
        canceled: "Pedido cancelado",
        deleted: "Pedido eliminado",
        delete_explanation:
          "El pedido y todas sus posiciones se eliminan definitivamente, como si nunca hubieran existido. Si el pedido realmente ocurrió, cancélalo en su lugar.",
        delete_blocked:
          "Este pedido solo se puede cancelar, no eliminar: existe una factura, un intento de pago o una reserva.",
        invoice_created: "Factura creada",
        invoice_ready: "La factura y su documento están listos.",
        invoice_document_failed:
          "No se pudo generar el documento, por lo que se descartó la factura. Revisa la plantilla de factura y crea la factura de nuevo.",
        document_ready: "Documento listo",
        document_missing: "No se generó ningún documento",
        skipped_item: "Posición #%{id}: %{reason}",
        skipped_item_of_order: "%{order}: %{reason}",
        created: "Pedido creado",
        buyer_without_billing_address:
          "Este comprador no tiene dirección de facturación (calle, código postal y ciudad). No se puede generar ninguna factura para el pedido.",
        processed: "Posiciones reservadas",
        search: "Buscar número de pedido u organización",
        more_events: "Más eventos",
        confirm_explanation: "El pedido pasa a ser vinculante. Se crean las reservas y pueden generarse facturas.",
        confirm_prepaid_explanation:
          "Pedido de prepago: confirmarlo sin un pago completado crea las reservas y envía las confirmaciones de inmediato, y las plazas ya no se liberan automáticamente. Aquí no se crea ninguna factura: emítela explícitamente. Un pago posterior se sigue facturando automáticamente.",
        checkout_failed: "Pago fallido: pedido cancelado",
        create_invoice_explanation: "Se facturarán estas líneas.",
        bulk_create_invoice_explanation:
          "Las reservas seleccionadas se agrupan en una factura por pedido (%{smart_count} pedido(s)). Las posiciones canceladas o ya facturadas se omiten.",
        bulk_create_order_invoice_explanation:
          "Se crea una factura por cada pedido seleccionado (%{smart_count} pedido(s)), que cubre todas las posiciones confirmadas y aún no facturadas. Los pedidos totalmente facturados o no confirmados se omiten.",
        bulk_order_invoice_nothing_selected: "Selecciona al menos un pedido.",
        bulk_create_item_invoice_explanation:
          "Las posiciones seleccionadas se agrupan en una factura por pedido (%{smart_count} pedido(s)). Las posiciones canceladas o ya facturadas se omiten.",
        bulk_item_invoice_nothing_selected: "Selecciona al menos una posición.",
        bulk_invoice_overrides:
          "Sustituciones opcionales aplicadas a todas las facturas creadas. Déjalo vacío y cada factura conserva su propia plantilla, título y período de servicio resueltos.",
        bulk_invoice_default_placeholder: "Valor predeterminado por pedido",
        bulk_invoice_bookings_without_order:
          "%{smart_count} reserva(s) seleccionada(s) no están vinculadas a un pedido y no se pueden facturar.",
        bulk_invoice_nothing_selected: "Ninguna de las reservas seleccionadas se puede facturar.",
        bulk_invoice_missing_addresses:
          "Un pedido no tiene una dirección de facturación válida y se omitirá: %{orders} |||| %{smart_count} pedidos no tienen una dirección de facturación válida y se omitirán: %{orders}",
        bulk_invoices_created: "%{smart_count} factura creada |||| %{smart_count} facturas creadas",
        bulk_invoices_skipped: "%{smart_count} posición(es) se omitieron (canceladas, ya facturadas o no confirmadas).",
        create_custom_invoice_explanation:
          "Todas las posiciones ya están facturadas. Añade líneas abajo para crear una factura personalizada.",
        invoice_recipient_without_address:
          "%{name} no tiene una dirección de facturación válida (calle, código postal y ciudad). Completa abajo los datos de facturación; de lo contrario no se puede crear ninguna factura.",
        invoice_nothing_selected: "Añade al menos una línea para facturar.",
        partially_processed: "Se reservaron %{count} posiciones. Las demás se enumeran a continuación.",
        process_order_explanation:
          "Crea una reserva para todas las %{count} posiciones abiertas y asignadas de este pedido. Las posiciones sin participante se omiten.",
        override_validation: "Omitir las comprobaciones de disponibilidad (capacidad, etc.) y permitir el sobrecupo.",
        override_validation_create:
          "Omitir comprobaciones (capacidad, plazo de inscripción) al crear, para sobreocupar.",
        override_validation_shortcut:
          "Atajo: mantén Mayús al hacer clic en la acción para activarlo solo para ese clic.",
        change_buyer:
          "El comprador solo puede cambiarse mientras no exista una factura. Los participantes de las posiciones no se cambian automáticamente.",
        cancel_explanation: "Se cancela todo el pedido y las reservas asociadas.",
        bulk_cancel_explanation:
          "Se cancelan %{smart_count} pedido(s) con todas sus posiciones y reservas. Los pedidos ya cancelados se omiten.",
        bulk_canceled: "Pedidos cancelados",
        bulk_cancel_skipped_entry: "#%{id}: %{reason}",
        bulk_cancel_nothing_open: "No queda nada por cancelar: la selección ya está cancelada.",
        bulk_cancel_no_credit_notes:
          "No se creó ninguna factura rectificativa ni de anulación: las facturas correspondientes ya están corregidas o anuladas.",
        reversal_invoice_rest: "Las facturas ya corregidas en parte reciben una factura rectificativa por el resto.",
        cancel_event_started: "Evento(s) ya iniciado(s): %{events}.",
        cancel_event_finished: "Evento(s) ya finalizado(s): %{events}.",
        cancel_event_elearning:
          "E-learning sin fecha fija: %{events}. Puede que ya haya comenzado o que ya se haya concedido el acceso.",
        no_invoices: "No hay facturas.",
        attendees: "Se crea una posición de pedido por cada persona seleccionada.",
      },
      labels: {
        no_orders: "Aún no tiene pedidos.",
        item_count: "%{smart_count} posición |||| %{smart_count} posiciones",
        seat_count: "%{smart_count} plaza |||| %{smart_count} plazas",
        more_events: "+ %{smart_count} evento más |||| + %{smart_count} eventos más",
        self_buyer: "Usted mismo",
        document: "Documento",
      },
    },
    order_items: {
      name: "Posición de pedido |||| Posiciones de pedido",
      processing_queue: "Por procesar",
      labels: {
        no_items: "Este pedido no tiene posiciones.",
      },
      filters: {
        processing_queue: "Vista",
        queue_open: "Elementos abiertos",
        queue_open_and_requests: "Elementos abiertos y cancelaciones solicitadas",
        queue_processed: "Elementos procesados",
        cancellation_requested: "Cancelación solicitada",
      },
      fields: {
        id: "ID",
        approval_url: "Enlace de aprobación",
        is_third_party: "Reservado para otra persona",
        price_type_name: "Tipo de precio",
        approval_emails: "Correos de aprobadores",
        state: "Estado",
        user: "Participante",
        event: "Evento",
        price: "Precio",
        offered_price: "Oferta",
        adjust_price: "Ajustar precio",
        invoiced_amount: "Facturado",
        attendees: "Participantes",
        format: "Formato",
        approval_status: "Aprobación",
        approval_reason: "Motivo",
        cancellation_reason: "Motivo de la cancelación (opcional)",
        canceled_at: "Cancelado el",
        created_at: "Creado el",
        price_amount: "Precio",
        notice: "Aviso",
      },
      state: {
        open: "Abierto",
        booked: "Reservado",
        denied: "Denegado",
        canceled: "Cancelado",
      },
      approval: {
        pending: "Aprobación pendiente",
        approved: "Aprobado",
        denied: "Rechazado",
      },
      actions: {
        cancel_emptied_orders: "Cancelar el pedido |||| Cancelar los pedidos (%{smart_count})",
        use_different_person: "Otro participante",
        use_buyer_as_attendee: "El comprador participa",
        adjust_price: "Ajustar precio",
        use_offer_price: "Usar el precio de la oferta",
        add: "Añadir posición",
        add_and_book: "Reservar directamente",
        edit: "Editar posición",
        edit_person_data: "Editar datos de la persona",
        edit_main_contact_info: "Editar datos de contacto",
        edit_invoice_contact_info: "Editar dirección de facturación",
        edit_invoice_dispatch_contact_info: "Editar dirección de envío de factura",
        use_from_source: "Copiar del pedido",
        use_custom_fields_and_confirm: "Copiar campos y usar",
        request_approval: "Solicitar aprobación",
        process: "Proceso",
        create_booking: "Crear la reserva",
        create_waiting_list_booking: "Crear reserva en lista de espera",
        use_person: "Usar esta persona",
        linked: "Vinculada",
        assign: "Asignar persona",
        reassign: "Reasignar persona",
        cancel: "Cancelar",
        request_cancellation: "Solicitar cancelación",
        request_cancellation_confirm:
          "¿Solicitar la cancelación de esta posición? La solicitud se revisa, no se cancela nada automáticamente.",
        request_cancellation_confirm_button: "Solicitar cancelación",
        request_cancellation_success: "La solicitud de cancelación se ha enviado.",
        request_cancellation_error: "La solicitud de cancelación falló. Por favor, inténtelo de nuevo.",
        cancellation_requested: "Cancelación solicitada",
        delete: "Eliminar posición",
        open_processing: "Procesar",
        quick_process: "Reserva rápida",
        previous_item: "Posición anterior",
        next_item: "Posición siguiente",
      },
      headlines: {
        custom_fields: "Datos de la reserva",
        lists: "Listas",
        consents: "Consentimientos",
        buyer: "Comprador",
        buyer_and_attendee: "Comprador y asistente",
        person_fields: "Datos personales",
        matching_persons: "Participantes existentes",
        processing: "Procesar posición de pedido",
        attendee: "Participante",
        purchase: "Oferta reservada",
        other_items: "Otras posiciones de este pedido",
        person: "Personas",
      },
      hints: {
        added: "Posición añadida",
        previous_value: "antes: %{value}",
        add_blocked_canceled: "Un pedido cancelado ya no se puede ampliar.",
        add_blocked_prepaid:
          "Un pedido prepagado no se puede ampliar. Cree un pedido aparte para la posición adicional.",
        price_locked_prepaid:
          "Este pedido es prepagado. Su precio ya no se puede cambiar: la página de pago cobra el importe con el que se creó el pedido. Cree un pedido aparte en su lugar.",
        cancel_prepaid:
          "Este pedido es prepagado. Cancelar no cambia el importe que su página de pago cobra o ya ha cobrado: concilie el pago manualmente después.",
        items_in_orders:
          "Las %{items} posiciones del pedido pertenecen a %{smart_count} pedido. |||| Las %{items} posiciones del pedido pertenecen a %{smart_count} pedidos.",
        orders_keep_items:
          "%{smart_count} de ellos tiene otras posiciones activas y se mantiene. |||| %{smart_count} de ellos tienen otras posiciones activas y se mantienen.",
        remaining_orders_emptied:
          "El pedido restante se quedaría sin posiciones activas. |||| Los %{smart_count} restantes se quedarían sin posiciones activas.",
        all_orders_keep_items:
          "El pedido tiene otras posiciones activas y se mantiene. |||| Los pedidos tienen otras posiciones activas y se mantienen.",
        cancel_emptied_orders:
          "De lo contrario, el pedido se quedaría sin posiciones activas. |||| De lo contrario, estos pedidos se quedarían sin posiciones activas.",
        credit_note_mixed:
          "Los pedidos cancelados reciben una factura de anulación; las facturas ya corregidas en parte, una factura rectificativa por el resto. En los demás pedidos se crea una factura rectificativa por las posiciones canceladas.",
        add_to_confirmed_order:
          "Este pedido ya está confirmado. La nueva posición no se factura automáticamente: la facturación sigue siendo un paso aparte.",
        book_requires_confirmed_order: "Solo se puede reservar una vez confirmado el pedido.",
        edit_invoiced_item:
          "Esta posición ya está facturada. Un cambio de precio no se factura ni se corrige automáticamente: emite otra factura o una factura rectificativa por la diferencia.",
        thank_you_headline: "¡Gracias! Sus datos han sido enviados con éxito.",
        approval: "Aprobar",
        mismatch_in_person_data:
          "Los datos guardados difieren de los de esta persona. ¿Copiar los valores guardados o mantener los existentes?",
        request_approval_explanation:
          "Envía la solicitud de aprobación a las direcciones indicadas. Cada aprobador recibe un enlace firmado para aprobar o denegar.",
        approval_requested: "Solicitud de aprobación enviada",
        approval_emails: "Separe varias direcciones con comas.",
        open_items_count: "%{count} elemento abierto |||| %{count} elementos abiertos",
        processed_items_count: "%{count} elemento procesado |||| %{count} elementos procesados",
        no_processable_items: "No hay elementos para procesar.",
        no_processed_items: "No hay elementos procesados.",
        unassigned: "Sin asignar",
        processing_hints: "%{smart_count} aviso antes de reservar |||| %{smart_count} avisos antes de reservar",
        event_fully_booked_short: "El evento ya está completo.",
        child_fully_booked_short: "El subevento %{names} ya está completo.",
        approval_denied_short: "La aprobación de esta posición fue rechazada",
        similar_booking_short: "Posible reserva duplicada - ya existe una reserva similar:",
        cancellation_requested_short: "Se solicitó una cancelación para esta posición",
        bulk_cancel_explanation:
          "Se cancelan %{smart_count} posición(es) junto con sus reservas. Las demás posiciones de sus pedidos no se modifican.",
        bulk_canceled: "Posiciones canceladas",
        processed: "Posición reservada",
        assigned: "Persona asignada",
        canceled: "Posición cancelada",
        deleted: "Posición eliminada",
        delete_explanation:
          "La posición se elimina definitivamente, como si nunca hubiera existido. Si realmente ocurrió, cancélala en su lugar.",
        delete_blocked:
          "Esta posición no se puede eliminar: está reservada o facturada, o es la última posición del pedido (elimina el pedido en su lugar).",
        cancel_explanation: "Esta posición se cancela y las reservas asociadas se cancelan.",
        process_explanation: "Crear una reserva para %{name} en %{event}.",
        quick_process:
          "Reserva rápida para posiciones ya asignadas. Para cotejar duplicados o asignar, abre la página de procesamiento.",
        matching_persons: "Personas existentes con un nombre o correo coincidente. Vincula una para evitar duplicados.",
        no_matching_persons: "No se encontraron personas coincidentes.",
        person_used: "Se utiliza",
        approval_for: "Aprobación de la inscripción",
      },
    },
    emails: {
      name: "Correo electrónico |||| Correos electrónicos",
      single_emails: "Correos individuales",
      is_archived: "Este correo electrónico está archivado",
      fields: {
        subject: "Asunto",
        template: "Plantilla",
        created_at: "Creado el",
        status: "Estado",
        to: "Para",
        bounce_reason: "Razón del rebote",
        scheduled_at: "Fecha de envío",
      },
      status: {
        waiting_for_transfer: "Esperando transferencia",
        transfered: "Transferido",
        sent: "Enviado",
        blocked: "Bloqueado",
        error: "Error de envío",
      },
      actions: {
        resend: "Reenviar",
      },
      hints: {
        undeliverableEmails:
          "No se entregará un correo electrónico |||| %{smart_count} correos electrónicos no serán entregados",
        duplicateRecipients:
          "Una dirección recibe varios correos electrónicos |||| %{smart_count} direcciones reciben varios correos electrónicos",
        noEmailAddress: "No hay dirección de correo electrónico disponible",
        noListConsentGiven: "No se ha dado el consentimiento para la lista",
      },
    },
    email_jobs: {
      name: "Envío de correo |||| Envíos de correo",
      is_archived: "Este envío de correo está archivado",
      fields: {
        created_at: "Creado el",
        sender: "Dirección del remitente",
        body: "Contenido",
        emails: "Para",
        attachments: "Archivos adjuntos",
        recipients: "Destinatarios",
        template: "Plantilla",
        created_by: "Creado por",
        custom_to: "Dirección de correo electrónico",
      },
      actions: {
        group_by_jobs: "Agrupar por envío",
      },
    },
    email_senders: {
      name: "Remitente del correo",
      fields: {
        name: "Nombre",
        email: "Correo electrónico",
        signature: "Firma",
        users: "Empleados autorizados",
        lecturers: "Profesores autorizados",
        external_id: "ID externa",
        use_for_reply: "Usar como dirección de respuesta",
      },
    },
    event_lecturers: {
      name: "Docente |||| Docentes",
    },
    events: {
      name: "Evento |||| Eventos",
      name_singular: "Evento",
      is_archived: "Este evento está archivado",
      invalid_archive_filter: 'El filtro de archivado está configurado en "Todos". No se puede archivar.',
      array_input_fields: {
        dates: "Fechas y horarios",
        group_children: "Evento |||| Eventos",
        group_parents: "Grupo de eventos |||| Grupos de eventos",
        prices: "Precio |||| Precios",
        lecturers: "Docente |||| Docentes",
      },
      bulk_update_dates: {
        has_day: "Cambiar día",
        has_time: "Cambiar hora",
        has_format: "Cambiar formato",
        has_location: "Cambiar ubicación",
      },
      fields: {
        id: "ID",
        attendees_max: "Participantes máx.",
        attendees_min: "Participantes mín.",
        capacity: "Capacidad",
        child_event_base: "Oferta",
        cost_center: "Centro de costos",
        cost_object: "Objeto de costo",
        project_number: "Número de proyecto",
        created_at: "Creado",
        event_base: "Oferta",
        event_base_group_parent: "Grupo de ofertas",
        group_parent: "Grupo de eventos",
        group_child: "Evento",
        external_url: "URL pública",
        first_day: "Fecha",
        last_day: "Último día del evento",
        first_day_end_time: "Hora de fin",
        first_day_start_time: "Hora de inicio",
        id_number: "Número",
        inventory_account: "Cuenta contable",
        is_bookable: "Reservable",
        format: "Formato del evento",
        is_solo_bookable: "Reservable individualmente",
        lecturers: "Docentes",
        location: "Lugar del evento",
        meta: {
          event_base_category_names: "Categorías",
          event_base_name: "Título de la oferta",
          event_base_type_name: "Tipo de oferta",
          all_valid_bookings_count: "Número de participantes",
        },
        online_invite_text: "Información de la reunión",
        prices: "Precios",
        registration_begin: "Inicio del periodo de inscripción",
        registration_deadline: "Fin del periodo de inscripción",
        remaining_dates: "Otras fechas",
        responsibilities: "Responsabilidades",
        responsible_persons: "Personas responsables",
        is_public: "Público",
        rooms: "Salas",
        status: "Estado",
        lecturers_may_edit_attendance: "Los docentes pueden editar la asistencia",
        display_in_portal: "Visible en el portal",
        is_billable: "Es facturable",
        bookings: "Reservas",
        event_location_name: "Nombre del lugar del evento",
        event_lecturer_names: "Nombres de los docentes",
        all_valid_bookings_count: "Número de reservas válidas",
        all_waiting_bookings_count: "Número de reservas en espera",
        is_child: "Evento en un grupo",
        is_parent: "Grupo de eventos",
        dates_count: "Número de fechas",
        dates: "Fechas",
        event_base__name: "Título de la oferta",
        event_base__event_type__name: "Tipo de oferta",
        location__name: "Lugar del evento",
      },
      actions: {
        new_event: "Crear nuevo",
        existing_event: "Adoptar datos",
        create_event: "Crear evento",
        change_status: "Cambiar estado",
        bulk_update: "Actualizar campos",
        change_format: "Cambiar formato",
        change_event_base: "Cambiar oferta",
        create_booking: "Agregar reserva",
        create_bookings: "Agregar reservas",
        select_persons: "Seleccionar personas",
        select_event: "Seleccionar evento",
        create_interest: "Agregar interesado/a",
        create_group: "Agrupar",
        add_moodle_course: "Vincular curso de Moodle",
        remove_moodle_course: "Eliminar vinculación de curso de Moodle",
        show_event_base: "Al oferta",
        add_to_event_group: "Agregar al grupo",
        add_child_event_to_group: "Agregar evento",
        duplicate: "Duplicar",
        add_lecturer: "Agregar docente",
        add_new_lecturer: "Crear y asignar docente",
        connect_existing_lecturer: "Asignar docente",
        edit_accounting_fields: "Editar campos contables",
        edit_responsibilities: "Editar responsabilidades para „%{responsibilityType}“",
        update_children_status: "Actualizar el estado de todos los eventos subordinados también",
        add_feedback_form: "Agregar formulario de retroalimentación",
        update_dates: "Editar fechas",
      },
      validation: {
        number_not_unique: "El número del evento ya está en uso",
      },
      headlines: {
        cancel_order_items: "Cancelar posiciones del pedido",
      },
      hints: {
        cancel_order_items_explanation:
          "El evento está cancelado. %{smart_count} posición(es) de pedidos confirmados siguen reservadas para él. ¿Cancelarlas junto con sus reservas? Las posiciones de otros eventos del mismo pedido no se modifican.",
      },
    },
    event_bases: {
      name: "Oferta |||| Ofertas",
      name_singular: "Oferta",
      is_archived: "Esta oferta está archivada",
      fields: {
        image_path: "Ruta de la imagen",
        name: "Nombre",
        slug: "Segmento de URL",
        summary: "Resumen",
        event_type: "Tipo",
        event_type_name: "Nombre del tipo de evento",
        contact_persons: "Personas de contacto",
        group_parent: "Grupo de oferta",
        partners: "Socios cooperativos",
        tags: "Palabras clave",
        contexts: "Entornos",
        categories: "Categorías",
        audiences: "Públicos",
        descriptions: "Descripciones",
        image: "Imagen",
        documents: "Documentos",
        created_at: "Creado",
        updated_at: "Actualizado",
        external_url: "URL pública",
        event_count: "Número de eventos",
        event_type__name: "Tipo",
      },
      actions: {
        duplicate: "Duplicar",
        new_event_base: "Nueva oferta",
        existing_event_base: "Oferta existente",
        change_event_type: "Cambiar tipo de oferta",
        create_event: "Añadir evento",
        create_event_base: "Crear oferta",
        create_event_base_child: "Crear suboferta",
        create_event_group: "Crear grupo de eventos",
        show_event_base_group: "Ir al grupo de ofertas",
        add_description_field: "Añadir campo",
        show_old_descriptions: "Mostrar descripciones antiguas",
        hide_old_descriptions: "Ocultar descripciones antiguas",
      },
    },
    event_base_descriptions: {
      name: "Descripción de la oferta |||| Descripciones de las ofertas",
      fields: {
        description_type: "Tipo de descripción",
        text: "Texto",
      },
    },
    event_base_description_fields: {
      name: "Campo de descripción |||| Campos de descripción",
      fields: {
        label: "Etiqueta",
        slug: "Identificador",
        field_type: "Tipo de campo",
        width: "Ancho",
        show_per_default: "Mostrar siempre",
        soft_required: "Requerido",
      },
    },
    event_dates: {
      name: "Fecha |||| Fechas",
      fields: {
        has_attended: "Asistió",
        id: "ID",
        event: "Evento",
        day: "Día",
        different_location: "Lugar diferente",
        start_time: "Inicio (hora)",
        end_time: "Fin (hora)",
        start_datetime: "Inicio",
        end_datetime: "Fin",
        location: "Lugar diferente",
        format: "Formato diferente",
      },
      headlines: {
        date: "Fecha",
        date_details: "Detalles de la fecha",
      },
      formats: {},
    },
    event_feedback_forms: {
      name: "Formulario de feedback del evento |||| Formularios de feedback del evento",
      fields: {
        event: "Evento",
        valid_until: "Válido hasta",
        feedback_form: "Formulario de retroalimentación",
        url: "URL del formulario",
        name: "Nombre del formulario",
        reporting_visible_for_lecturers: "Evaluación visible para los profesores",
      },
      actions: {
        download_qr_code: "Descargar código QR",
        remove_from_event: "Eliminar de evento",
        edit: "Editar formulario de retroalimentación",
      },
      labels: {
        additional_text: "Explicación",
        add_text_response: "Añadir respuesta de texto",
      },
    },
    event_locations: {
      name: "Lugar del evento |||| Lugares del evento",
      fields: {
        image_path: "Ruta de la imagen",
        name: "Nombre",
        email: "Correo electrónico",
        rooms: "Salas",
        url: "URL",
        lat: "Latitud",
        lon: "Longitud",
        info: "Información",
        address: userFields.contact_info,
      },
    },
    event_moodle_courses: {
      name: "Vinculación de curso de Moodle |||| Vinculaciones de curso de Moodle",
      actions: {
        disconnect_moodle_course: "Desconectar vinculación de curso de Moodle",
      },
    },
    event_rooms: {
      name: "Sala del evento |||| Salas del evento",
      fields: {
        identifier: "Identificación de la sala",
        location_name: "Lugar del evento",
      },
    },
    event_types: {
      name: "Tipo de oferta |||| Tipos de oferta",
      template_hint:
        "Estas plantillas se aplican a los pedidos y reservas de este tipo de oferta. Un pedido que abarca varios tipos de oferta usa la plantilla predeterminada del sistema. Si una plantilla se deja vacía, se usa la predeterminada.",
      array_input_fields: {
        description_fields: "Campo de descripción |||| Campos de descripción",
      },
      fields: {
        name: "Nombre",
        invoice_template: "Plantilla de factura",
        invoice_mail_template: "Plantilla de correo de factura",
        booking_confirmation_template: "Plantilla de confirmación de correo de reserva",
        order_manual_processing: "Procesamiento de pedidos",
      },
      order_manual_processing_hint:
        "Los pedidos que combinan líneas manuales y automáticas se procesan siempre manualmente.",
      order_manual_processing_choices: {
        inherit: "Usar configuración general (%{value})",
        manual: "Manual",
        auto: "Automático",
      },
      headlines: {
        settings: "Configuración de visualización",
        templates: "Plantillas",
      },
    },
    external_email_templates: {
      name: "Plantilla de correo electrónico |||| Plantillas de correos electrónicos",
      fields: {
        scope: "Alcance",
        external_id: "ID externa",
        subject: "Asunto",
        sender: "Remitente estándar",
        is_default: "Plantilla predeterminada",
        bcc: "Dirección de correo electrónico BCC",
        language: "Idioma",
        parent_template: "Plantilla superior",
        recipient_role: "Destinatario",
        recipient_contact_info_type: "Tipo de dirección",
      },
      helper_texts: {
        recipient_role: "Si el pedido no tiene organización, la persona que realizó el pedido recibe el correo.",
      },
      array_input_fields: {
        content_blocks: "Bloques de contenido",
        event_blocks: "Bloques de eventos",
      },
      headlines: {
        scope_info: "Descripción de los ámbitos",
      },
    },
    feedback_forms: {
      name: "Formulario de comentarios |||| Formularios de comentarios",
      fields: {
        name: "Nombre",
        introduction: "Introducción",
        closing_remark: "Comentario final",
        questions: "Preguntas",
      },
      array_input_fields: {
        questions: "Preguntas",
      },
      actions: {
        add_question: "Agregar pregunta",
        add_as_new_question: "Agregar como nueva pregunta",
        send: "Enviar comentarios",
        group_questions: "Agrupar por preguntas",
        add_question_group: "Agregar grupo de preguntas",
        add_question_group_template: "Añadir plantilla de grupo de preguntas",
        new_question: "Nueva pregunta",
        existing_question: "Pregunta existente",
        duplicate: "Duplicado",
      },
    },
    feedback_form_question_groups: {
      name: "Grupo de preguntas |||| Grupos de preguntas",
      fields: {
        name: "Nombre",
        description: "Descripción",
      },
      template: "Plantilla de grupos de preguntas",
      hints: {
        load_from_template:
          "El grupo de preguntas seleccionado, incluidas las preguntas, se añadirá al cuestionario de comentarios que aparece a continuación. Si las preguntas ya están presentes en el cuestionario de comentarios, se ignorarán y no se incluirán.",
      },
    },
    question_select_values: {
      name: "Opción de selección |||| Opciones de selección",
      fields: {
        value: "Valor",
      },
    },
    files: {
      name: "Documento |||| Documentos",
      fields: {
        file_size: "Tamaño del archivo",
        variant_urls: "URL de las variantes de imagen",
        id: "ID",
        data: "Datos",
        related_id: "ID relacionada",
        related_resource: "Recurso relacionado",
        mime_types: "Tipos MIME",
        created_by: "Creado por",
        created_at: "Creado el",
        url: "URL",
        description: "Descripción",
        name: "Nombre",
        name_sortable: "Nombre",
        original_filename: "Nombre de archivo",
        tags: "Etiquetas",
        visible_for_all: "Público",
        visible_for_attendees: "Liberado para los participantes en el portal",
        visible_for_lecturers: "Liberado para profesores en el portal",
        visibility: "Aprobaciones",
      },
      actions: {
        open: "Abrir archivo",
      },
      hints: {
        file_not_previewable: "No es posible previsualizar este formato de archivo.",
      },
    },
    generated_documents: {
      name: "Documento creado automáticamente |||| Documentos creados automáticamente",
      hints: {
        persist_on_relation:
          "El documento se almacena en el registro de datos actual (%{relationName}) y es visible para los empleados. Se pueden asignar autorizaciones adicionales: |||| Los documentos se almacenan en %{relationName} y son visibles para los empleados. Se pueden asignar más autorizaciones:",
      },
    },
    generate_document_tasks: {
      name: "Tarea de generación de documentos |||| Tareas de generación de documentos",
    },
    integrated_applications: {
      name: "Aplicación vinculada |||| Aplicaciones vinculadas",
      fields: {
        active: "Activo",
        name: "Nombre",
      },
      labels: {
        activate: "Activar",
        deactivate: "Desactivar",
        inactive: "Inactivo",
        active: "Activo",
        connect: "Conectar",
        disconnect: "Separar",
        finish_oauth_connect: "Finalizar conexión OAuth",
      },
    },
    interests: {
      name: "Interesado/a |||| Interesados",
      fields: {
        person: "Persona",
        event_base_or_event: "Oferta / Evento",
        event_name: "Evento",
        user_full_name: "Nombre",
        created_at: "Creado",
        user__last_name: "Apellido",
        note: "Nota",
      },
      actions: {
        remove: "Eliminar favorito",
        edit: "Editar interés",
      },
    },
    invoices: {
      name: "Factura |||| Facturas",
      headlines: {
        covered_items: "Posiciones facturadas",
        related: "Facturas relacionadas",
        covered_line_items: "Líneas ya facturadas y gratuitas (%{count})",
        preview: "Vista previa",
        details: "Detalles",
      },
      fields: {
        title: "Título",
        first_name: "Nombre",
        last_name: "Apellido",
        organization_name: "Nombre de la organización",
        is_organization: "Es organización",
        debit_number: "Número de deudor",
        parent: "Factura original",
        sum_without_tax: "Total neto",
        kind: "Tipo",
        template: "Plantilla de factura",
        override_contact_info: "Sobrescribir información de contacto",
        price: "Precio",
        name: "Título",
        download: "Descargar",
        invoice_number: "Número de factura",
        service_period: "Período de servicio",
        generated_at: "Generado",
        created_at: "Fecha de factura",
        due_date: "Fecha de vencimiento",
        sent_at: "Enviado",
        recipient: "Destinatario/-a de la factura",
        payment: "Pago",
        accounting_transfer_success_at: "Transferido",
        accounting_transfer_error: "Error de transmisión",
        is_paid: "Pagado",
        price_gross: "Bruto",
        price_net: "Neto",
        credited: "menos facturas rectificativas y de anulación",
        effective: "Importe efectivo",
        booking__event__event_base__name: "Título de la oferta",
        booking__attendee__last_name: "Apellido",
        buyer_name: "Comprador/a",
        order__order_number: "Número de pedido",
        paid_amount: "Importe pagado",
        external_accounting_id: "ID de contabilidad",
        recipient_name: "Nombre del destinatario",
        reference: "Factura de referencia",
        referenced_by: "Referenciada por",
      },
      actions: {
        show_booking: "A la reserva",
        show_order: "Al pedido",
        download: "Descargar factura",
        set_is_paid: "Marcar como pagado",
        unset_is_paid: "Marcar como no pagado",
        bulk_reversal: "Cancelar",
        reverse: "Anular",
        correct: "Corregir",
        add_line_item: "Añadir posición",
        drop_line_item: "Eliminar",
        open_in_external_accounting: "Abrir en contabilidad",
        sync_with_external_accounting: "Sincronizar con la contabilidad",
        reset_accounting_transfer: "Restablecer transferencia",
      },
      kinds: {
        standard: "Standard",
        correction: "Factura rectificativa",
        reversal: "Factura de anulación",
      },
      hints: {
        unresolved_accounting_lines_title: "Campos contables ausentes",
        unresolved_accounting_lines_hint: "Estos eventos aún no tienen campos contables:",
        accounting_transfer_error_hint: "Se ha producido un error durante la transmisión:",
        due_on: "Vence el %{date}",
        pdf_not_generated: "El documento de la factura aún no se ha generado.",
        reference: "Una factura de este pedido a la que se refiere el documento.",
        reverse_explanation: "Esto anula toda la factura con una factura de anulación. No se puede deshacer.",
        correct_explanation: "Estas líneas se crearán como factura rectificativa.",
        reversal_created: "Factura de anulación creada",
        document_generation_failed: "No se pudo generar el documento. Revisa la plantilla de factura.",
        correction_created: "Factura rectificativa creada",
        reversal_partially_skipped:
          "Factura de anulación creada; se omitieron %{count} factura(s) porque no se pudieron anular.",
        accounting_transfer_started: "Transferencia a contabilidad iniciada",
        reset_accounting_transfer_success: "Restablecimiento de la transmisión completado con éxito",
        reset_accounting_transfer_error: "Error al restablecer la transmisión",
        reset_accounting_transfer_hint:
          "¿Desea realmente cancelar la transferencia? Esto provocará la pérdida de los datos contables y se podrá iniciar una nueva transferencia.",
        no_invoice_templates_present: "Debe existir un modelo de factura (%{kind}) para poder crear una factura.",
        line_item_already_invoiced: "Esta línea ya está facturada. Añada solo lo que se cobra adicionalmente.",
        line_item_free: "Línea gratuita: nada que facturar. Añada solo lo que se cobra adicionalmente.",
        line_item_not_billed: "No facturado",
        discarded_after_document_failure:
          "La factura se descartó porque no se pudo generar ningún documento. |||| Las facturas se descartaron porque no se pudieron generar los documentos.",
        credit_amount_negative: "El importe de la corrección debe ser negativo.",
        credit_amount_positive: "La corrección de una línea de descuento es un importe positivo.",
        correction_nothing_selected: "Al menos una línea de factura debe conservar sus líneas de corrección.",
        bulk_reversal_placeholder:
          "El marcador de posición %{invoiceNumber} se sustituye por el número de factura original correspondiente al generar la factura.",
      },
    },
    invoice_tax_amounts: {
      name: "Importe de impuesto por tipo |||| Importes de impuesto por tipo",
      fields: {
        tax_rate: "Tipo impositivo",
        amount: "Importe del impuesto",
      },
    },
    invoice_templates: {
      name: "Modelo de factura |||| Modelos de factura",
      fields: {
        name: "Nombre",
        zugferd_tax_exemption_reason_text: "Motivo de la exención fiscal",
        zugferd_payment_terms_description: "Descripción de las condiciones de pago",
        zugferd_payment_means_code_type: "Tipo de código del medio de pago",
        is_default: "Default Template",
      },
      hints: {
        zugferd_fields: "ZUGFeRD Fields",
      },
    },
    lecturers: {
      name: "Docente |||| Docentes",
      fields: userFields,
      is_archived: "Este/a docente está archivado",
      actions: {
        enroll_to_moodle_courses: "Inscribir docente en curso Moodle",
      },
    },
    notes: {
      name: "Nota |||| Notas",
      fields: {
        high_priority: "Fijado",
        text: "Texto",
      },
      actions: {
        pin: "Fijar",
        unpin: "Desprender",
        delete: "Eliminar",
        create: "Crear nota",
        update: "Actualizar nota",
      },
    },
    contact_infos: {
      name: "Información de contacto |||| Informaciones de contacto",
      fields: userFields.contact_info,
    },
    moodle_courses: {
      name: "Curso Moodle |||| Cursos Moodle",
      fields: {
        id_number: "Número de curso",
        name: "Nombre del curso",
        category: "Categoría",
        short_name: "Nombre corto del curso",
        start_date: "Inicio del curso",
        end_date: "Fin del curso",
      },
      actions: {
        connect: "Vincular con curso existente",
        delete: "Eliminar curso también en Moodle",
        create_new: "Crear y vincular nuevo curso",
        enroll_remaining_attendees:
          "%{numberOfAttendees} más participante con cuenta Moodle |||| %{numberOfAttendees} más participantes con cuenta Moodle",
        enroll_all_valid_attendees: "Inscribir participantes con cuenta Moodle en el curso",
      },
      moodle_course_has_no_users_enrolled: "Aún no se han inscrito participantes en este curso.",
      moodle_course_number_of_enrolled_bookings: "%{numberEnrollments} de %{numberBookings} participantes inscritos",
      connected_lecturers: "Docentes vinculados",
    },
    moodle_enrollments: {
      name: "Inscripción en Moodle |||| Inscripciones en Moodle",
      history_change: "para %{userName} en el curso %{courseName}",
    },
    moodle_users: {
      name: "Cuenta de Moodle |||| Cuentas de Moodle",
      is_connected_with_moodle: "Está vinculado con una",
      actions: {
        delete: "Eliminar cuenta también en Moodle",
      },
      moodle_number_of_enrollments_info:
        "Se inscribirá %{smart_count} %{resource} en los cursos seleccionados de Moodle |||| Se inscribirán %{smart_count} %{resource} en los cursos seleccionados de Moodle",
    },
    o_auth_apps: {
      name: "Aplicación OAuth |||| Aplicaciones OAuth",
      fields: {
        is_superapplication: "Aplicación Admin",
        client_type: "Tipo de Cliente",
        client_id: "ID del Cliente",
        client_secret: "Secreto del Cliente",
        authorization_grant_type: "Tipo de Concesión de Autorización",
        auth_groups: "Grupos de Permisos",
        redirect_uris: "URIs de Redirección",
        post_logout_redirect_uris: "URIs de Redirección tras el Cierre de Sesión",
        skip_authorization: "Omitir Autorización",
        pkce_required: "PKCE Requerido",
        algorithm: "Algoritmo",
        application_permissions: "Permisos",
      },
      helper_texts: {
        client_secret_create: "Déjelo vacío para generar un secreto automáticamente.",
        client_secret_edit: "Oculto por motivos de seguridad. Déjelo vacío para mantener el secreto actual.",
      },
    },
    occupancy: {
      name: "Ocupación",
      fields: {
        unprocessed_order_items: "posición de pedido no procesada |||| posiciones de pedido no procesadas",
        held_order_seats: "plaza reservada (pedido) |||| plazas reservadas (pedidos)",
        attendees_max: "de máx. %{max} participantes",
        attendees_min_reached: "Cantidad mínima %{min} alcanzada",
        attendees_min: "hasta la cantidad mínima %{min}",
        waiting: "en espera",
        vacant_bookings: "lugar disponible |||| lugares disponibles",
        vacant_waiting_hint: "%{count} en lista de espera",
      },
    },
    organizations: {
      name: "Organización |||| Organizaciones",
      is_archived: "Esta organización está archivada",
      self_created: "Creada por",
      actions: {
        quick_create: "Crear nueva organización",
      },
      fields: {
        id: "ID",
        invoice_contact_info: "Factura",
        invoice_dispatch_contact_info: "Envío de factura",
        name: "Nombre",
        tags: "Etiquetas",
        debit_number: "Número de deudor",
        value_added_tax_id: "NIF/CIF",
        trade_register_number: "Número de registro mercantil",
        self_created_by: "Creada en autoservicio por",
        fiscal_number: "Número fiscal",
        created_at: "Creado el",
      },
    },

    organization_memberships: {
      name: "Pertenencia a la organización |||| Pertenencias a organizaciones",
    },

    organization_users: {
      name: "Persona |||| Personas",
      labels: {
        no_members: "Todavía no hay personas asignadas a esta organización.",
      },
      fields: {
        organization: "Organización",
        user: "Persona",
        permissions: "Permisos",
        can_edit_organization: "Puede editar la organización",
        can_enroll: "Puede realizar pedidos",
        can_manage_users: "Puede gestionar personas",
        create_login: "Crear acceso al portal",
        created_at: "Creado el",
      },
      hints: {
        create_login: "La persona recibe un correo para configurar su acceso.",
      },
      actions: {
        disconnect: "Eliminar vinculación",
        add_member: "Añadir persona",
        select_existing_organization: "Organización existente",
        create_new_organization: "Nueva organización",
      },
    },
    price_types: {
      name: "Tipo de precio |||| Tipos de precio",
      fields: {
        name: "Nombre",
        short_name: "Abreviatura",
      },
      is_archived: "Este tipo de precio está archivado",
      for_free: "Gratuito",
    },
    price_positions: {
      name: "Posición |||| Posiciones",
      default_first_position_name: "Participación",
      fields: {
        sales_tax: "Impuesto sobre las ventas",
        attendee_name: "Participante",
        event_name: "Evento",
        event_id_number: "Número de evento",
        amount: "Cantidad",
        name: "Nombre",
        quantity: "Cantidad",
        inventory_account: "Cuenta contable",
        tax_rate: "IVA",
        incl_tax: "IVA incl. %{amount}",
      },
    },
    prices: {
      name: "Precio |||| Precios",
      fields: {
        amount: "Cantidad",
        cached_amount: "Cantidad",
        positions: "Posiciones",
        price_type: "Tipo de precio",
        price_type_name: "Nombre del tipo de precio",
        valid_from: "Válido desde",
        valid_until: "Válido hasta",
      },
      labels: {
        amount: "Importe",
        invoiced_amount: "Importe facturado",
        paid_amount: "Estado del pago",
        paid: "Pagado",
        price_override: "Precio ajustado manualmente",
      },
      tooltips: {
        amount:
          "El importe a pagar y su tipo de precio. Cero significa «gratuito», salvo cuando el importe es cero solo porque se cancelaron todas las posiciones; en ese caso se muestra el importe.",
        invoiced_amount:
          "En cuanto se factura parte del importe, la suma facturada aparece delante: en gris mientras sea inferior al importe, en naranja si lo supera. Cuando todo está facturado, el importe se muestra en verde.",
        paid_amount:
          "Una doble marca verde indica que se ha pagado el importe completo; una sola marca, que se ha pagado todo lo facturado hasta ahora. Un pago parcial se muestra como importe. Sin ninguna marca, aún no se ha pagado nada.",
      },
    },
    partners: {
      name: "Socio cooperativo",
      fields: {
        logo_path: "Ruta del logotipo",
        id: "ID",
        name: "Nombre",
        url: "URL",
        logo: "Logo",
      },
    },
    qualifications: {
      name: "Cualificación |||| Cualificaciones",
    },
    questions: {
      name: "Pregunta |||| Preguntas",
      fields: {
        type: "Tipo de pregunta",
      },
      types: {
        RATING: "Valoración",
        SINGLE_CHOICE: "Selección única",
        MULTIPLE_CHOICE: "Selección múltiple",
        FREE_TEXT: "Texto libre",
      },
    },
    report: {
      name: "Evaluación",
    },
    response_forms: {
      name: "Evaluación de comentarios",
      filters: {
        feedback_form: "Cuestionario",
        event: "Evento",
        lecturers: "Docentes",
        event_base: "Propuesta",
        responsible_person: "Persona responsable",
        question: "Pregunta",
        date_to: "Creado hasta",
        date_from: "Creado por",
        question_type: "Tipo de pregunta",
      },
    },
    responses: {
      name: "Respuesta |||| Respuestas",
    },
    responsibilities: {
      name: "Responsabilidad |||| Responsabilidades",
    },
    responsibility_types: {
      name: "Tipo de responsabilidad |||| Tipos de responsabilidad",
      fields: {
        event_types: "Tipos de oferta",
      },
    },
    settings: {
      name: "General",
      fields: {
        value: "Valor",
        key: "Configuración",
      },
    },
    webhook_subscriptions: {
      name: "Webhook Subscription |||| Webhook Subscriptions",
    },
    subscriptions: {
      name: "Webhook |||| Webhooks",
      fields: {
        name: "Nombre",
        is_active: "Activo",
        endpoint_url: "URL del punto final",
        event_types: "Eventos",
        secret: "Secreto",
      },
      helper_texts: {
        secret_edit: "Oculto por motivos de seguridad. Déjelo vacío para mantener el secreto actual.",
      },
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      fields: {
        name: "Nombre",
      },
    },
    tax_rates: {
      name: "Tasa de impuesto sobre las ventas |||| Tasas de impuesto sobre las ventas",
      fields: {
        amount: "Porcentaje",
        untdid_category: "Categoría UNTDID 5305",
        is_default: "Usar como predeterminado",
      },
    },
    users: {
      name: "Persona |||| Personas",
      fields: userFields,
      is_archived: "La persona está archivada",
      actions: {
        quick_create: "Crear nueva persona",
        add_invoice_contact_info: "Añadir dirección de facturación distinta",
        connect_moodle_account: "Vincular cuenta de Moodle |||| Vincular cuentas de Moodle",
        disconnect_moodle_user: "Desvincular cuenta de Moodle",
        unenroll_moodle_enrollment: "Darse de baja del curso de Moodle",
        suspend_moodle_enrollment: "Establecer como inactivo",
        unsuspend_moodle_enrollment: "Establecer como activo",
        add_login: "Agregar inicio de sesión |||| Agregar inicios de sesión",
        remove_login: "Eliminar inicio de sesión",
        change_email: "Cambiar correo electrónico",
        add_attendee_role: "Añadir rol de participante |||| Añadir roles de participante",
        add_lecturer_role: "Añadir rol de docente |||| Añadir roles de docente",
        remove_attendee_role: "Quitar rol de participante",
        remove_lecturer_role: "Quitar rol de docente",
        create_interest: "Agregar interesado/a",
      },
      login: {
        name: "Nombre",
        email: "Correo electrónico",
        comment: "Comentario",
      },
      gender: {
        male: "Masculino",
        female: "Femenino",
        non_binary: "No binario",
      },
    },
    user_moodle_users: {
      name: "Vinculación de cuenta de Moodle |||| Vinculaciones de cuenta de Moodle",
    },
    staff_members: {
      name: "Empleado/a |||| Empleados",
      is_archived: "Este empleado está archivado",
      fields: {
        ...userFields,
        roles: "Grupos de permisos",
        is_2fa_required: "Autenticación de dos factores requerida",
        color: "Color",
        email_senders: "Remitentes de correo electrónico asignados",
      },
    },
    two_factor: {
      name: "Autenticación de dos factores",
      actions: {
        reset_2fa: "Restablecer 2FA",
      },
      confirm: "¿Realmente restablecer la autenticación de dos factores?",
      success: "Autenticación de dos factores restablecida con éxito",
      error: "No se pudo restablecer la autenticación de dos factores.",
    },
    custom_field_content_types: {
      name: customFieldContentTypeName,
      content_types: {
        organization_users: "Personas de la organización",
      },
      fields: {
        resource: "Área",
        slug: "Identificador",
        custom_fields: customFieldContentTypeName,
      },
    },
    custom_fields: {
      name: "Campo de datos maestros avanzado |||| Campos de datos maestros avanzados",
      array_input_fields: {
        custom_fields: "Campo |||| Campos",
      },
      actions: {
        add_field: "Agregar campo",
        add_custom_field_section: "Añadir área",
      },
      notification: {
        slug_not_unique: "La etiqueta/el identificador no son únicos.",
      },
      headlines: {
        attendee_fields: "Campos de participantes",
        booking_fields: "Campos de reserva",
      },
      fields: {
        label: "Etiqueta",
        slug: "Identificador",
        field_type: "Tipo de campo",
        data_type: "Tipo de datos",
        width: "Ancho",
        show_per_default: "Mostrar siempre",
        soft_required: "Requerido",
        allowed_for_enrollment: "Permitir para inscripciones",
        allowed_for_order: "Permitir para pedidos",
        allow_multiple_select: "Permitir selección múltiple",
        editable_by_user: "Editable en el portal",
        editable_by_buyer: "Rellenable al pedir",
        visible_for_attendees: "Liberado para los participantes en el portal",
        visible_for_lecturers: "Liberado para profesores en el portal",
        relation_content_type: "Tipo de contenido",
        field_types: {
          TEXT: "Texto",
          TEXTAREA: "Área de texto",
          RICHTEXT: "Editor de texto enriquecido",
          NUMBER: "Número",
          DATE: "Fecha",
          BOOLEAN: "Sí / No",
          SELECT: "Selección",
          RELATION: "Relación",
          RELATION_MANY: "Relación (múltiple)",
        },
        field_info: {
          TEXT: "campo de texto de una línea",
          TEXTAREA: "campo de texto de varias líneas",
          RICHTEXT: "Texto enriquecido",
          NUMBER: "campo numérico",
          DATE: "campo de fecha",
          BOOLEAN: "campo Sí / No",
          SELECT: "campo de selección",
          RELATION: "Relación",
          RELATION_MANY: "Relación (múltiple)",
        },
      },
    },
    todo_lists: {
      name: "Lista de tareas |||| Listas de tareas",
      fields: {
        name: "Nombre",
      },
      array_input_fields: {
        todos: "Tareas",
      },
      actions: {
        add: "Crear lista",
        add_template_list: "Cargar plantilla de lista",
        edit: "Editar lista",
      },
    },
    todos: {
      name: "Tarea |||| Tareas",
      actions: {
        add: "Añadir tarea",
        edit: "Editar tarea",
        showDone: "Mostrar tareas realizadas recientemente",
        hideDone: "Ocultar tareas realizadas recientemente",
      },
      fields: {
        assignee: "Persona asignada",
        due_date: "Fecha de vencimiento",
        text: "Texto",
        is_done: "Completado",
        event__first_day: "Evento",
      },
      filters: {
        due_date__lte: "Vence hasta",
      },
      own_todos: "Mis tareas",
      no_todos: "Actualmente no tiene tareas pendientes.",
      no_done_todos: "No tiene tareas completadas hasta ahora.",
      hints: {
        reorder_error: "No se ha podido guardar el nuevo orden.",
      },
    },
    user_list_configurations: {
      actions: {
        rename: "Renombrar",
        manage_filters: "Mostrar filtros",
        save_as_new: "Guardar como nueva vista",
        save_view: "Guardar vista",
        save_changes: "Guardar cambios",
      },
      hints: {
        error_loading_configuration: "Error al cargar las vistas personalizadas",
      },
    },
    user_lists: {
      name: "Lista |||| Listas",
      fields: {
        name: "Nombre",
        is_public: "Visible / editable en el portal",
        brevo_id: "ID de Lista de Brevo",
        consent_type: "Tipo de consentimiento",
        users: "Personas",
        user_list: "Lista",
        description: "Descripción",
        brevo_list_name: "Nombre de la Lista de Brevo",
        brevo_folder: "Carpeta de Brevo",
        consent_given: "Consentimiento ya otorgado",
        no_consent: "Sin consentimiento",
        consent_method: "Consentimientos",
        trigger_confirmation: "Activar proceso de consentimiento (Double-Opt-In)",
      },
      actions: {
        add_persons: "Agregar personas",
        remove_from_list: "Eliminar de la lista",
        sync_to_brevo: "Sincronizar con Brevo",
        import_from_brevo: "Importar contactos desde Brevo",
        connect_existing_brevo_list: "Conectar lista de Brevo existente",
        connect_new_brevo_list: "Crear nueva lista de Brevo",
        sync_list: "Sincronizar lista",
        save_and_sync: "Guardar y sincronizar",
      },
      consent_dialog: {
        add_title: "Consentimiento requerido",
        add_message: "¿Desea aceptar este consentimiento para ser añadido a la lista?",
        accept_consent: "Aceptar y añadir a la lista",
        remove_title: "Eliminar consentimiento",
        remove_message: "¿También desea eliminar su consentimiento? Será eliminado de la lista de todas formas.",
        keep_consent: "Mantener consentimiento",
        remove_consent: "Eliminar consentimiento",
      },
      hints: {
        brevo_sync_info:
          "Vincula una lista de Brevo: las personas se sincronizarán automáticamente. Usa 'Sincronizar lista' para aplicar cambios manualmente. Solo se envían datos nuevos a Brevo, no se elimina nada.",
        brevo_migrate_info:
          "Los contactos de la lista de Brevo vinculada se importarán a EDM. Si hay un usuario con el mismo email de acceso en EDM, se reutiliza. Si no, se crea un nuevo 'contacto' en EDM.",
        unsubscribe_success: "Se ha dado de baja correctamente de la lista.",
        unsubscribe_failure: "La baja de la lista ha fallado.",
      },
      sections: {
        subscribable: "Listas suscribibles",
      },
      filters: {
        consent_status: "Consentido",
      },
      notifications: {
        successfully_added_users: "Persona añadida a la lista |||| Personas añadidas a la lista",
        successfully_updated_list: "Lista actualizada exitosamente",
      },
    },
    user_list_data: {
      name: "Lista Suscrita |||| Listas Suscritas",
      fields: {
        combined_first_name: "Nombre",
        combined_last_name: "Apellido",
        created_at: "Fecha de creación",
        combined_email: "Correo electrónico",
        is_synced: "Sincronizado",
        user__first_name: "Nombre",
        user__last_name: "Apellido",
        user__contact_infos__email: "Correo electrónico",
      },
      filters: {
        type: "Tipo",
        contacts: "Contactos",
        users: "Personas",
      },
      actions: {
        remove_consent: "Eliminar también el consentimiento",
      },
      hints: {
        remove_confirm:
          "¿De verdad desea eliminar a esta persona de la lista? Tenga en cuenta que si hay una lista Brevo vinculada, la persona también se eliminará de la lista en Brevo.",
      },
    },
  },
  page_sections: {
    actions: "Acciones",
    orders: "Pedidos",
    relations: "Asignaciones",
    sales: "Informes",
    bookings: "Reservas",
    bookings_files: "Documentos de reserva",
    child_event_bases: "Subofertas",
    contact_infos: "Información de contacto",
    core_data: "Datos principales",
    description: "Descripción",
    direct_bookings: "Reservas directas",
    event_groups: "Grupos de eventos",
    events: "Eventos",
    extended: "Ampliado",
    files: "Documentos",
    general: "Visión general",
    groups: "Grupos",
    high_priority_notes: "Notas importantes",
    history: "Historia",
    image: "Imagen",
    interested_users: "Interesados",
    waiting_users: "Lista de espera",
    potential_attendees: "Potenciales participantes",
    interests: "Intereses",
    login: "Iniciar sesión",
    moodle: "Moodle",
    notes: "Notas",
    password_reset: "Restablecer contraseña",
    prices: "Precios",
    related_notes: "Notas relacionadas",
    settings: "Configuración",
    profile: "Perfil",
    feedback_form: "Formularios de retroalimentación",
    questions: "Preguntas",
    question_groups: "Plantillas de grupos de preguntas",
    feedback: "Retroalimentación",
    attendance: "Asistencia",
    activity: "Actividad",
    twofa: "Autenticación de dos factores",
    password_change: "Gestión de contraseñas",
    visit_website: "Al sitio web",
    language_versions: "Variantes lingüísticas",
    attendees: "Participante |||| Participantes",
    emails: "Emails",
    persons: "Personas",
    organizations: "Organizaciones",
  },
  menu_sections: {
    export: "Exportar",
    bookings: "Reservas",
    communication: "Comunicación",
    participants: "Participantes",
    roles_access: "Roles y acceso",
    moodle: "Moodle",
    manage: "Gestionar",
  },
  password_reset: {
    success: "La nueva contraseña ha sido establecida",
    failure: "Error al establecer la contraseña. Por favor, solicite de nuevo.",
    submit: "Establecer nueva contraseña",
    passwordsUnequal: "no coincide con la contraseña",
    passwordEmpty: "Falta una contraseña",
    fields: {
      password: "Contraseña",
      passwordConfirm: "Confirmación de contraseña",
    },
  },
  filters: {
    attendance_event_type: "Tipo de participación",
    attendance_category: "Categoría",
    attendance_event_base: "Oferta",
    attendance_tags: "Etiqueta",
    bookings: {
      attendee_state: "Estado (Comunicación)",
      attendee_state_invoice: "Estado (Factura)",
      first_event_day_from: "Evento desde",
      first_event_day_to: "Evento hasta",
      created_at_from: "Reservado desde",
      created_at_to: "Reservado hasta",
      group_bookings: "Reservas grupales",
      booking_number: "Número de reserva",
      event_in: "Eventos",
      context: "Entorno",
      order_status: "Estado del pedido",
      order_organization: "Organización (pedido)",
    },
    categories: {
      has_parent_category: "Tiene categoría principal",
      parent_category_isnull: "Es categoría principal",
    },
    context: "Entorno",
    current: "En curso",
    created_at_from: "Creado desde",
    created_at_to: "Creado hasta",
    custom_field_date_from: "%{label} desde",
    custom_field_date_to: "%{label} hasta",
    events: {
      first_day_from: "Desde",
      first_day_to: "Hasta",
      number_or_event_base_title: "Número / Título de la oferta",
      fully_booked: "Completo",
      modules: "Módulos",
      hide_modules: "Sin módulos",
      modules_only: "Solo módulos",
    },
    groups_only: "Solo grupos",
    have_attended: "Asistido",
    history: {
      from: "Desde",
      to: "Hasta",
      changed_by: "Cambiado por",
      resource: "Tipo",
    },
    invoices: {
      is_paid: "Está pagado",
    },
    is_archived: "Archivado",
    is_self_created: "Creada por usuario",
    is_bookable: "Reservable",
    is_public: "Público",
    name: "Nombre",
    search: "Buscar",
    solo_event_bases_only: "Solo ofertas individuales",
    solo_events_only: "Solo eventos individuales",
    users: userAndEnrollmentFilters,
    upcoming: "Próximos",
    user_list: "Lista",
    waitinglist_events: "Eventos de lista de espera",
    valid_booking_event: "Eventos reservados",
    consent_type: "Tipo de consentimiento",
    completion_status: "Estado de envío",
    incomplete_email_jobs: "Solo incompletos",
    complete_email_jobs: "Solo completos",
    organizations: "Organizaciones",
  },
  hints: {
    event_date_details_inherited: "Los datos atenuados provienen de los datos maestros del evento.",
    all_price_types_taken:
      "Se ha asignado un precio para cada tipo de precio. Para poder agregar más precios, primero se debe crear un tipo de precio adicional.",
    user_without_email_present:
      "El conjunto de datos seleccionado necesita una dirección de correo electrónico. |||| Todos los conjuntos de datos seleccionados necesitan una dirección de correo electrónico.",
    accounting_invoice_already_present: "Ya se ha transferido una factura con este número de factura.",
    child_of: "incluido en",
    custom_field_models_present: "Ya existen %{resource} donde %{field} está establecido.",
    delete_invoice_with_children: "Eliminar una factura solo es posible si no hay otras facturas relacionadas.",
    disabled_add_dates:
      "Las fechas de un grupo de eventos se generan a partir de las fechas de los eventos correspondientes.",
    event_bulk_update:
      "Los campos rellenados se sobrescriben en todos los eventos seleccionados. Los campos vacíos permanecen sin cambios y los eventos subordinados no se modifican.",
    unchanged: "Sin cambios",
    event_status_label: "Estado: %{status}",
    files_are_private:
      "Este archivo es privado y solo se puede acceder a él desde aquí. |||| Estos archivos son privados y solo se puede acceder a ellos desde aquí.",
    files_are_public:
      "Este archivo está disponible públicamente y puede ser visto por todos los que tengan el enlace. |||| Estos archivos son públicos y pueden ser vistos por todos los que tengan el enlace.",
    group_bookings_selected: "Se han seleccionado reservas de grupo",
    invoice_override_prices:
      "Normalmente se usa el precio actual de la reserva seleccionada para crear la factura. |||| Normalmente se usan los precios actuales de las reservas seleccionadas para crear las facturas.",
    is_event_group: "Grupo de eventos",
    is_event_base_group: "Grupo de ofertas",
    is_group: "Grupo",
    is_group_booking: "Reserva de grupo",
    link_to_event_base: "A la página de ofertas",
    external_sender_sync_hint:
      "Por favor, especifíquelo solo si el remitente ya existe en Brevo y no debe ser creado nuevamente.",
    sender_delete_message: "¿Está seguro de que desea eliminar este remitente de correo?",
    login: {
      all_users_have_login:
        "%{resource} ya tiene un inicio de sesión |||| Todos los %{resource} ya tienen un inicio de sesión",
      created: "Inicio de sesión creado",
      email_absent: "No hay correo electrónico de inicio de sesión presente",
      email_exists:
        'Si el correo electrónico de inicio de sesión ya existe, los participantes pueden ser fusionados con la función "Fusionar".',
      not_all_users_have_login:
        "%{resource} aún no tiene un inicio de sesión |||| No todos los %{resource} tienen un inicio de sesión",
      present: "Inicio de sesión presente",
      will_be_created: "Se creará el inicio de sesión",
      email_empty: "El inicio de sesión solo se puede crear con un correo electrónico válido",
      consent_info:
        "Al crear los inicios de sesión, las personas dan automáticamente su consentimiento para el uso del portal de participantes/docentes. No hay un proceso de doble opt-in. Por favor, asegúrese de que esto se desea así.",
      remove_confirm:
        "Elimina el inicio de sesión de %{name}. El registro de la persona se conserva; solo se elimina su acceso al portal de participantes/docentes.",
    },
    role: {
      remove_attendee_confirm:
        "Quita el rol de participante de %{name}. El registro de la persona se conserva; solo se eliminan los datos específicos del participante (rol de audiencia, número de débito, campos personalizados).",
      remove_lecturer_confirm:
        "Quita el rol de docente de %{name}. El registro de la persona se conserva; solo se eliminan los datos específicos del docente (honorarios, cualificaciones, categorías, campos personalizados).",
    },
    moodle: {
      all_connected: "%{resource} ya está conectado |||| Todos los %{resource} ya están conectados",
      connect_error: "Error al conectar",
      connected: "ya está conectado",
      course_enrolled_users_count: "%{enrolledUsersCount} de %{bookingsCount} participantes inscritos",
      course_without_enrollments: "Aún no se han inscrito participantes en este curso.",
      not_all_users_have_account: "No todos los %{resource} tienen una cuenta Moodle",
      no_linked_courses: "Aún no se han vinculado cursos de Moodle con este evento",
      present: "está vinculado con una cuenta de Moodle existente (%{info})",
      will_be_created: "se creará en Moodle",
      has_moodle_account: "Cuenta de Moodle vinculada",
    },
    payment: {
      self_managed: "Pago gestionado por el propio participante",
    },
    event_type_necessary_for_resource: "El tipo de oferta debe establecerse antes de que se puedan crear %{resource}.",
    no_prices_present: "No hay precios disponibles para este evento.",
    non_bookable_group_child: "El evento no se puede reservar individualmente",
    update_main_contact_info: "Usar dirección de comunicación del registro para el/la participante",
    update_invoice_contact_info: "Usar dirección de facturación del registro para el/la participante",
    update_invoice_dispatch_contact_info: "Usar dirección de envío de facturas del registro para el/la participante",
    all_users_have_login: "Todos los %{resource} tienen un inicio de sesión",
    login_email_exists:
      'Si el correo electrónico de inicio de sesión ya existe, los participantes pueden ser fusionados con la función "Fusionar".',
    login_email_absent: "No hay correo electrónico de inicio de sesión disponible",
    sub_record_fetch_error:
      "%{resource} para %{parentResource} no se pudo cargar. |||| %{resource} para %{parentResource} no se pudieron cargar.",
    report: {
      data_info_headline: "Base de datos",
      data_info_content:
        'Los datos subyacentes se filtran según el estado del evento dependiendo del período seleccionado. Para períodos en el pasado, se utilizan eventos (reservaciones de) con estado "GO" y "Completado". Para períodos en el futuro, se utilizan eventos (reservaciones de) con estado "Ofrecido" y "GO".',
      data_info_headline_bookings: "Reservaciones",
      data_info_content_bookings:
        "Si una reserva se considera para el período seleccionado siempre depende de la fecha de inicio del evento, la fecha de la reserva en sí no importa.",
    },
    bulk_selection_limit_exceeded:
      "Advertencia: Se han seleccionado más de 1000 entradas. Esto puede causar errores en el procesamiento masivo.",
    similar_attendee_already_exists:
      "Ya existen reservaciones para este evento con datos similares para las siguientes personas: %{names}. Por favor, asegúrese de que no se trate de una doble reserva involuntaria.",
    permission_denied_info:
      "Ha realizado una acción para la cual no tiene permisos. Si necesita permisos adicionales, por favor contacte a su administrador.",
    current_user_roles: "Sus grupos de permisos actuales",
    custom_field_select_already_used:
      "El valor de este campo ya está registrado en %{count} %{resource}. ¿Desea aún así editar la selección? Los valores antiguos se mantienen tras cambios y no se actualizan.",
    feedback_module_of: "Módulo de retroalimentación de",
    feedback_not_found_headline: "No se pudo encontrar un formulario de retroalimentación adecuado para este enlace",
    feedback_not_found_info:
      "Por favor, compruebe que el enlace es correcto. Posiblemente también haya expirado la validez del enlace.",
    copied_to_clipboard: "Copiado al portapapeles.",
    custom_field_slug_already_exists_elswhere:
      "Este slug ya existe para %{resource}. La duplicación puede dar lugar a que los datos con este slug se adopten tanto para la reserva como para el/la participante. Si esto no es lo deseado, se debe usar otro slug.",
    enrollment_already_approved: "Este registro ya ha sido procesado.",
    enrollment_not_found_headline: "No se pudo encontrar un registro adecuado para este enlace",
    error_info:
      "Lamentablemente, ha surgido un error al procesar su solicitud. Esto generalmente indica un problema técnico en EDM. Si el error persiste, por favor contacte a nuestro soporte: ",
    not_found_info:
      "Lamentablemente, no se pudo encontrar la página que solicitó. Por favor, compruebe la URL o contacte a nuestro soporte en caso de duda: ",
    only_canceled_bookings_can_be_archived: "Solo las reservas canceladas pueden ser archivadas.",
    add_lecturers_to_event_children: "Profesor para asignar adicionalmente estos subcursos:",
    change_event_base_with_child_or_parent:
      "Este evento forma parte de un grupo de eventos. Tenga en cuenta que solo se modificará la oferta del evento actual. Los eventos superiores o subordinados deben editarse por separado.",
    sender_delete_external: "Eliminar también del servicio de correo electrónico externo (Brevo)",
  },
  validations: {
    url: "URL no es válida (debe comenzar con http:// o https://)",
    slug_chars: "solo letras, números y - válidos",
    registration_begin_after_deadline:
      "La fecha de inicio de registro debe ser anterior o igual a la fecha límite de registro",
    registration_deadline_before_begin:
      "La fecha límite de registro debe ser posterior o igual a la fecha de inicio de registro",
    first_day_after_last_day: "El primer día debe ser anterior o igual al último día",
    last_day_before_first_day: "El último día debe ser posterior o igual al primer día",
    attendees_min_greater_than_max:
      "El número mínimo de asistentes debe ser menor o igual al número máximo de asistentes",
    attendees_max_less_than_min: "El número máximo de asistentes debe ser mayor o igual al número mínimo de asistentes",
    start_time_after_end_time: "La hora de inicio debe ser anterior o igual a la hora de fin",
    end_time_before_start_time: "La hora de fin debe ser posterior o igual a la hora de inicio",
  },
  confirmations: {
    moodle: {
      disonnect_user: "¿Desconectar a %{name} (%{email}) de Moodle?",
      connect_user_create: "¿Crear una cuenta para %{name} (%{email}) en Moodle?",
      connect_user_with_existing:
        "Ya existe una cuenta con la dirección de correo %{email} en Moodle. ¿Desea vincular la cuenta de todos modos?",
      unenroll_moodle_enrollments:
        "¿Se debe dar de baja a %{moodleUser} del curso %{courseName}? |||| ¿Desea dar de baja a los participantes seleccionados del curso %{courseName}?",
      suspend_moodle_enrollments:
        "¿Se debe establecer %{moodleUser} como inactivo en el curso %{courseName}? |||| ¿Se debe establecer como inactivas a las personas seleccionadas en el curso %{courseName}?",
      unsuspend_moodle_enrollments:
        "¿Se debe establecer %{moodleUser} como activo en el curso %{courseName}? |||| ¿Se debe establecer como activas a las personas seleccionadas en el curso %{courseName}?",
      disonnect_course: "¿Desconectar a %{name} de Moodle?",
    },
    event_title: "Campos recomendados para el evento no completados",
    event_text:
      "No todos los campos recomendados para este evento han sido completados. Esto puede llevar, por ejemplo, a una representación incompleta del evento en la página web. Los siguientes campos recomendados no están completados:",
    event_fields: "Campos del evento:",
    event_base_change_bookings_present: "Existen reservas",
    event_base_change_explanation:
      "Al cambiar la oferta, la descripción de contenido para este evento puede cambiar. ¿Desea modificar la oferta para este evento de todos modos?",
    event_base_fields: "Campos de la oferta:",
    event_save_anyway: "Publicar de todos modos",
    event_save_draft: "Guardar como borrador",
    event_base_save_anyway: "Guardar de todos modos",
    event_base_failed_soft_validation_title: "Campos recomendados para la oferta no completados",
    event_base_failed_soft_validation_text:
      "No todos los campos recomendados para esta oferta han sido completados. Esto puede llevar, por ejemplo, a una representación incompleta del evento en la p��gina web. Los siguientes campos recomendados no están completados:",
    delete_invoice:
      'Tenga en cuenta que al hacer clic en "Confirmar", la factura seleccionada será eliminada irreversiblemente. Esto puede causar problemas contables y/o fiscales si la factura ya está en circulación.',
    delete_custom_field:
      "De verdad desea eliminar este campo? Al hacerlo, también se eliminarán todos los datos que pueda contener.",
    delete_custom_field_section:
      "De verdad desea eliminar esta sección? También se eliminarán todos los campos que contenga, así como los datos que pueda contener.",
    delete_following_custom_fields: "Se eliminarán los siguientes campos (incluidos los datos almacenados):",
    delete_custom_field_with_data:
      "Existe un registro donde %{label} está configurado. |||| Existen %{smart_count} registros donde %{label} está configurado.",
    edit_invoice:
      "Tenga en cuenta que está a punto de editar una factura ya existente. Esto puede causar problemas contables y/o fiscales si la factura ya está en circulación.",
    failed_soft_validation_title: "Campos recomendados no completados",
    failed_soft_validation_text:
      "No se han completado todos los campos recomendados para este registro. Los siguientes campos recomendados faltan:",
    check_values_title: "Revisar datos",
    check_values_text: "Revise antes de guardar:",
    slug_changed_title: "Identificador modificado",
    slug_changed_text:
      "Las descripciones existentes están vinculadas al campo de descripción mediante su identificador. ¿Desea trasladar las descripciones ya introducidas de este tipo de oferta al nuevo identificador? De lo contrario, perderán su vínculo.",
    slug_changed_move_descriptions: "Trasladar descripciones",
    slug_changed_keep_descriptions: "Guardar solo el campo",

    non_template_descriptions_present_title: "Descripciones ya no válidas",
    non_template_descriptions_present_text:
      "%{smartCountDescriptions} ya no son compatibles con los campos de descripción del nuevo tipo de oferta.",
    remove_from_event_group: "¿Desea realmente eliminar este evento del grupo de eventos?",
    remove_from_event_base_group: "¿Desea realmente eliminar esta oferta del grupo de ofertas?",
    remove_lecturer_from_event: "¿Desea realmente eliminar a este/a profesor/a del evento?",
    event_base_name_already_present: "Título de la oferta ya existente",
    event_base_name_already_present_explanation:
      "El título de la oferta ya existe fuera de un grupo. Por esta razón, esta oferta no puede ser eliminada del grupo. Por favor renombre una de las ofertas primero.",
    group_mark_as_attended:
      'Como se trata de reservas de un grupo de eventos, esta acción afecta a todos los subeventos. Los participantes seleccionados serán marcados como "ha asistido" en todos los subeventos.',
    group_mark_as_unattended:
      'Como se trata de reservas de un grupo de eventos, esta acción afecta a todos los subeventos. Los participantes seleccionados serán marcados como "no ha asistido" en todos los subeventos.',
    add_as_interests: '¿Desea agregar las reservas seleccionadas también como "Interesado"?',
    alter_bookings:
      "Las personas seleccionadas se inscriben en el evento seleccionado abajo. En el evento actual, su estado se cambia a «Reservado de nuevo».",
    custom_field_select_edit_anyway: "Editar selección de todos modos",
    unsaved_changes_dialog: "Ha realizado cambios en el formulario. ¿Desea realmente cerrar el diálogo?",
    close_dialog: "¿Desea realmente cerrar el diálogo?",
    delete_feedback_form:
      "¿Desea realmente eliminar este formulario de retroalimentación? Si ya existen respuestas para este formulario, también serán eliminadas.",
    delete_question_group:
      "¿Desea realmente eliminar este grupo de preguntas? Todas las preguntas dentro del grupo se eliminarán del formulario de retroalimentación. Si ya existen respuestas para las preguntas contenidas, también serán eliminadas.",
    delete_question:
      "¿Desea realmente eliminar esta pregunta? Si ya existen respuestas para esta pregunta, también serán eliminadas.",
    delete_user:
      "Cuando se ejecuta esta acción, todos los datos del usuario se eliminarán de forma permanente. Se excluyen las reservas, las facturas asociadas y los correos electrónicos enviados. Los compradores de pedidos abiertos no pueden eliminarse hasta que el pedido se cancele o se complete.",
    delete_organization:
      "La organización, sus datos de contacto, miembros y campos personalizados se eliminarán de forma permanente. Las organizaciones con pedidos no se pueden eliminar; archívelas en su lugar.",
    bulk_attendances_different_values: "Algunas reservas ya tienen otros valores asignados para la asistencia:",
    values_will_be_overwritten: "Estos valores se sobrescribirán. ¿Desea continuar de todos modos?",
  },
  settings: {
    relative_commission_per_booking: {
      name: "Comisión relativa por reserva",
      description: "Este factor se utiliza para calcular la comisión relativa por reserva.",
    },
    automated_data_deletion_active: {
      name: "Eliminación automática de registros de usuarios y facturas",
      description: "Activar la eliminación automática de registros de usuarios y facturas en todo el sistema.",
    },
    automated_data_deletion_user_threshold_days: {
      name: "Umbral de eliminación de usuarios en días",
      description: "Después de cuántos días se eliminan automáticamente los usuarios.",
    },
    automated_data_deletion_invoice_threshold_days: {
      name: "Umbral de eliminación de facturas en días",
      description: "Después de cuántos días se eliminan automáticamente las facturas.",
    },
    relative_commission_eur_cap_per_booking: {
      name: "Límite máximo de comisión relativa por reserva (€)",
      description: "La cantidad máxima en euros que se puede calcular por reserva como comisión relativa.",
    },
    fix_commission_per_booking: {
      name: "Comisión fija por reserva (€)",
      description: "Esta cantidad se calcula por reserva además de la comisión relativa.",
    },
    fix_commission_per_month: {
      name: "Comisión fija por mes (€)",
      description: "Esta cantidad se calcula fija por mes.",
    },
    default_event_location: {
      name: "Ubicación del evento predeterminada",
      description: "Esta ubicación del evento se preselecciona al crear eventos.",
    },
    default_event_type: {
      name: "Tipo de oferta predeterminado",
      description: "Este tipo de oferta se preselecciona al crear ofertas.",
    },
    default_price_type: {
      name: "Tipo de precio predeterminado",
      description: "Este tipo de precio se preselecciona al crear reservas.",
    },
    logo_path: {
      name: "URL del logo",
      description: "La URL del logo deseado en el área de registro.",
    },
    login_text: {
      name: "Texto de inicio de sesión",
      description: "Texto informativo que se muestra al iniciar sesión.",
    },
    imprint_url: {
      name: "URL del Aviso Legal",
      description: "La URL del aviso legal en el área de inicio de sesión.",
    },
    data_privacy_url: {
      name: "URL de Privacidad de Datos",
      description: "La URL de privacidad de datos en el área de inicio de sesión.",
    },
    stripe_api_key: {
      name: "API Key",
      description: "Der API Key, den Sie von stripe erhalten.",
    },
    stripe_cancel_redirect: {
      name: "Weiterleitung bei Fehler",
      description: "Die URL, zu der nach einem Abbruch des Checkouts, weitergeleitet wird.",
    },
    stripe_success_redirect: {
      name: "Weiterleitung bei Erfolg",
      description: "Die URL, zu der nach einem erfolgreichen Checkout weitergeleitet wird.",
    },
    stripe_invoice_name: {
      name: "Rechnungsname",
      description: "Der Bezeichner, der für die Rechungsdokumente verwendet wird.",
    },
    stripe_webhook_secret: {
      name: "Webhook secret",
      description: "Das Webhook secret von Stripe.",
    },
    scopevisio_customer_id: {
      name: "ID de Cliente de Scopevisio",
      description: "El número de cliente de Scopevisio",
    },
    scopevisio_refresh_token: {
      name: "Token de actualización de Scopevisio",
      description: "Este token se utiliza para acceder a la API de Scopevisio",
    },
    scopevisio_webhook_secret: {
      name: "Secreto de webhook de Scopevisio",
      description: "Se espera en el encabezado X-Scopevisio-Webhook-Secret",
    },
    moodle_api_token: {
      name: "Token de API de Moodle",
      description: "Este token se utiliza para acceder a la API de Moodle",
    },
    moodle_attendee_role_id: {
      name: "Rol de participante",
      description: "Este rol se asigna a los participantes al inscribirse",
    },
    moodle_host: {
      name: "Host de Moodle",
      description: "El nombre de host del servidor donde se ejecuta la instancia de Moodle",
    },
    moodle_lecturer_role_id: {
      name: "Rol de docente",
      description: "Este rol se asigna a los docentes al inscribirse",
    },
    moodle_service: {
      name: "Servicio web de Moodle",
      description: "El nombre del servicio web registrado en el servidor de Moodle",
    },
    moodle_url: {
      name: "URL de Moodle",
      description: "URL de la instancia de Moodle (se utiliza para enlaces)",
    },
    custom_theme: {
      name: "Tema personalizado para el portal EDM",
      description: "Tema de Material UI para el portal EDM (participantes y docentes).",
    },
    days_lecturers_may_change_attendance_after_event: {
      name: "Fin de edición para participación por docentes",
      description: "Cuántos días después del final del evento pueden los docentes seguir editando la participación",
    },
    is_portal_active: {
      name: "Portal EDM para participantes y docentes",
      description: "Activar el portal EDM para participantes y docentes",
    },
    website_url: {
      name: "Website URL",
      description: "La URL de su propio sitio web. Se enlaza en el portal, por ejemplo.",
    },
    lecturer_booking_export_active: {
      name: "Los profesores pueden exportar reservas",
      description: "¿Debería aparecer en el portal una función de exportación de reservas para los profesores?",
    },
    lecturer_emailing_active: {
      name: "Los profesores pueden enviar correos electrónicos",
      description: "¿Debería mostrarse una función de correo electrónico en el portal para los profesores?",
    },
    favicon_url: {
      name: "Favicon-URL",
      description: "La URL del favicon deseado para las páginas públicas.",
    },
    read_emails_independent_of_sender: {
      name: "Los empleados pueden ver todos los correos electrónicos",
      description: "Los empleados pueden ver los correos electrónicos independientemente del remitente",
    },
    storefront_config: {
      name: "Configuración del escaparate",
      description: "Configuración para la vitrina",
    },
    public_portal_registration: {
      name: "Formulario de registro público (portal)",
      description: "El formulario de registro para el portal debe ser de acceso público?",
    },
    read_only: "Esta configuración no se puede cambiar aquí.",
    default_bcc: {
      name: "BCC par défaut",
      description: "Adresse e-mail ajoutée en CCI sur tous les e-mails sortants.",
    },
    frontend_event_base_path: {
      name: "Chemin de l'offre",
      description: "Modèle de chemin pour les pages d'offres. Paramètre : {slug}",
    },
    frontend_event_path_segment: {
      name: "Segment de chemin de l'événement",
      description: "Segment de chemin pour les événements individuels. Paramètre : {id}",
    },
    groups: {
      general: "Configuration générale",
      portal: "Portail",
      defaults: "Valeurs par défaut",
      storefront: "Site web",
      orders: "Pedidos y facturas",
    },
    order_validation_capacity: {
      name: "Comprobar aforo",
      description: "Comprueba si un pedido supera el número máximo de participantes de un evento.",
    },
    order_validation_registration_window: {
      name: "Comprobar periodo de inscripción",
      description: "Comprueba si un pedido llega dentro del periodo de inscripción de un evento.",
    },
    order_validation_event_started: {
      name: "Comprobar inicio del evento",
      description: "Comprueba si un evento ya ha comenzado en el momento del pedido.",
    },
    order_validation_levels: {
      off: "Desactivado",
      internal: "Aceptar siempre pedidos de clientes",
      everywhere: "Comprobar siempre",
      help: "Aceptar siempre pedidos de clientes: los pedidos a través del sitio web, formularios de inscripción y la API se aceptan sin comprobación. El error solo aparece cuando el personal procesa o confirma un pedido así. Si los pedidos se reservan automáticamente, el participante se reserva de todos modos.\nComprobar siempre: los pedidos de clientes también se rechazan.",
    },
    order_validation_billing_address: {
      name: "Aplicar comprobación de dirección de facturación",
      description:
        "Rechazar pedidos que se facturarán cuando el comprador no tenga una dirección de facturación válida. En pedidos de una organización cuenta la dirección de la organización. Solo se aplica a pedidos procesados automáticamente; con procesamiento manual, el error solo aparece al crear la factura.",
    },
    order_checkout_window_minutes: {
      name: "Ventana de pago (minutos)",
      description: "Cuánto tiempo un pedido pendiente reserva plazas durante el pago.",
    },
    order_manual_processing: {
      name: "Procesamiento manual de pedidos",
      description:
        "Si está activado, las líneas del pedido permanecen abiertas hasta que el personal las procese en una reserva. Si está desactivado, las líneas se reservan automáticamente al confirmar el pedido. Los tipos de oferta pueden anular esta configuración.",
    },
    order_unverified_user_retention_days: {
      name: "Conservación de personas no verificadas (días)",
      description:
        "Después de cuántos días se eliminan los registros de personas no verificadas creados por ellas mismas. Las personas con una reserva, un pedido abierto o una línea facturada se conservan siempre. 0 = sin eliminación.",
    },
    invoice_payment_term_days: {
      name: "Plazo de pago (días)",
      description:
        "Cuántos días después de la fecha de la factura vence una factura. La fecha de vencimiento se guarda al crear la factura y se transmite a contabilidad. 0 = sin fecha de vencimiento.",
    },
    debit_number_start_index: {
      name: "Inicio del rango de números de deudor",
      description: "Primer número que asigna EDM.",
    },
    debit_number_end_index: {
      name: "Fin del rango de números de deudor",
      description:
        "Último número del rango. Vacío = ilimitado. Si el rango está completo, la creación de facturas falla.",
    },
    organization_debit_number_start_index: {
      name: "Inicio del rango de números de deudor para organizaciones",
      description: "Rango propio opcional para organizaciones. Vacío = las organizaciones usan el rango anterior.",
    },
    organization_debit_number_end_index: {
      name: "Fin del rango de números de deudor para organizaciones",
      description: "Último número del rango de organizaciones. Vacío = ilimitado.",
    },
    debit_number_ranges: {
      help: "Rangos de los que EDM asigna nuevos números de deudor (asignados por contabilidad). Los cambios solo afectan a los números asignados a partir de ahora; los ya asignados se mantienen.",
      errors: {
        end_without_start: "Un final requiere un inicio.",
        end_before_start: "El final debe ser mayor o igual que el inicio.",
        overlap: "Los rangos para personas y organizaciones se solapan. Un final vacío cuenta como ilimitado.",
      },
    },
    invoice_auto_accounting_transfer: {
      name: "Transferir facturas a contabilidad automáticamente",
      description:
        "Si está activo, las facturas recién creadas se transfieren automáticamente a contabilidad. Las facturas creadas automáticamente - con el procesamiento manual de pedidos desactivado y tras un pago en línea correcto - se transfieren independientemente de esta configuración.",
    },
    create_organization_with_account: {
      name: "Ofrecer creación de organización al registrarse",
      description: "Permitir que los usuarios creen una organización al registrar una cuenta.",
    },
    cancellation_period: {
      name: "Período de cancelación (días)",
      description:
        "Número de días después de la creación de la reserva durante los cuales es posible la cancelación. 0 = no es posible la cancelación.",
    },
    cancellation_contact_email: {
      name: "Correo de contacto de cancelación",
      description:
        "Dirección de correo electrónico que recibe notificaciones cuando se cancela una reserva en el portal.",
    },
    headlines: {
      emailing: "Correos electrónicos",
      links: "Enlaces",
      lecturers: "Docentes",
      cancellation: "Cancelación",
      data_deletion: "Eliminación de datos",
      order_processing: "Procesamiento de pedidos",
      availability_checks: "Comprobaciones de disponibilidad",
      invoicing: "Facturas",
      debit_number_ranges: "Rangos de números de deudor",
    },
  },
  sidebar: {
    admin_section: "Administración",
    accounting_section: "Ventas",
    users_section: "Personas",
    imprint: "Imprint",
    data_privacy: "Privacidad de datos",
    info: "Información",
    administration: {
      main_data: "Datos principales",
      user_management: "Acceso",
      template_management: "Plantillas",
      settings: "Configuraciones",
    },
  },
  empty_state: "No hay %{entity} disponible.",
  no_category: "Sin categoría",
  no_date: "Sin fecha",
  no_event_base: "Sin oferta",
  no_value: "Sin valor",
  no_state: "Sin región",
  oclock: "%{time} horas",
  all: "Todos",
  already_taken: "ya está ocupado",
  born: "nac. %{date}",
  no_name: "Sin nombre (#%{id})",
  "Bad Request": "Solicitud fallida",
  Forbidden: "Sin permiso para esta acción",
  "Not Found": "Registro no encontrado",
  Unauthorized: "No permitido",
  "Internal Server Error": "Error del Servidor Interno",
  "NetworkError when attempting to fetch resource.": "Error de red al intentar obtener el recurso.",
  invalid_grant: "Credenciales inválidas",
  login_error: "Inicio de sesión no disponible actualmente",
  login_error_message:
    "Lamentablemente, ocurrió un error al comunicarse con el servidor. Por favor, inténtelo de nuevo o contacte a los administradores.",
  try_again: "Intentar de nuevo",
  enlarge: "Ampliar",
  shrink: "Reducir",
  notification: {
    login_created: "Inicio de sesión añadido |||| Inicios de sesión añadidos",
    connect_success: "%{entity} conectado exitosamente",
    disconnect_success: "%{entity} desconectado exitosamente",
    disconnect_error: "Error al desconectar %{entity}",
    moodle: {
      connect_error: "Error al conectar %{entity}",
      enrollment_success: "%{resource} inscrito exitosamente",
      enrollment_error: "Error al inscribir %{resource}",
      unenroll_success: "%{resource} desinscrito exitosamente",
      unenroll_error: "Error al desinscribir %{resource}",
      suspend_success: "%{resource} se ha establecido correctamente como inactivo.",
      suspend_error: "No se ha podido establecer %{resource} como inactivo.",
      unsuspend_success: "%{resource} se ha establecido correctamente como activo.",
      unsuspend_error: "No se ha podido establecer %{resource} como activo.",
      create_error: "No se pudo crear %{entity}",
    },
    remove_from_group_error: "Error al eliminar del grupo",
    remove_from_group_success: "Eliminado del grupo",
    upload_error: "Error al subir.",
    upload_error_reason: "Error al subir: %{reason}",
    unsupported_file_type: "Este tipo de archivo no es compatible. Tipos permitidos: %{types}.",
    upload_success: "Subida exitosa",
    check_for_password_reset: "Correo de restablecimiento de contraseña enviado",
    password_reset_error: "Correo electrónico no válido o no existente",
    delete_error: "Error al eliminar el registro",
    delete_price_enrollment_error:
      "El precio no se puede eliminar porque existen %{entityCount} %{enrollment} sin procesar con este precio.",
    duplicate_todos_error: "Error al duplicar las tareas. El evento se creó de todos modos.",
  },
  archiving: {
    archive: "Archivar",
    archive_confirm: "¿Realmente archivar %{resource}? |||| ¿Archivar %{entityCount} %{resource}?",
    archive_success: "%{resource} archivado exitosamente",
    archive_error: "Error al archivar",
    events_affected: "Eventos afectados: ",
    unarchive: "Restaurar",
    unarchive_confirm: "¿Realmente restaurar %{resource}? |||| ¿Restaurar %{entityCount} %{resource}?",
    unarchive_success: "%{resource} restaurado exitosamente",
    unarchive_error: "Error al restaurar",
    valid_bookings_affected: "Reservas válidas afectadas: ",
  },
  editor: {
    hints: {
      bold: "Negrita",
      italic: "Cursiva",
      heading1: "Encabezado 1",
      heading2: "Encabezado 2",
      heading3: "Encabezado 3",
      undo: "Deshacer",
      redo: "Rehacer",
      paragraph: "Párrafo",
      list: "Lista",
      numberedList: "Lista numerada",
      todoList: "Lista de tareas",
      link: "Enlace",
    },
  },
  emailing: {
    attachments: "Archivos adjuntos",
    attendance_confirmation: "Enviar confirmación de asistencia",
    body: "Contenido",
    booking_confirmation: "Enviar confirmación de reserva",
    order_confirmation: "Enviar confirmación de pedido",
    content_blocks: "Bloques de contenido",
    event_blocks: "Bloques de eventos",
    email_interested_users: "Contactar interesado/a |||| Contactar interesados",
    feedback: "Enviar formulario de retroalimentación",
    invoice_kind: "Tipo de factura",
    invoice_not_found: "No se pudo asociar una factura al destinatario y por lo tanto no se puede enviar.",
    no_body: "El contenido del correo electrónico no está disponible actualmente.",
    open_errors: "Errores sin resolver",
    related_records: "Registros relacionados",
    archive_job_hint: "Todos los correos electrónicos de este envío también se archivan.",
    unarchive_job_hint:
      "Todos los correos electrónicos de este envío también se restauran, incluidos los archivados individualmente.",
    no_template: "Ninguna plantilla seleccionada",
    no_receivers: "No hay destinatarios válidos disponibles",
    no_templates_for_scope: "Todavía no hay plantillas de correo electrónico para este ámbito.",
    no_assigned_senders: "Aún no ha asignado ningún remitente de correo electrónico.",
    receivers: "Destinatarios",
    send: "Enviar",
    send_email: "Enviar correo electrónico",
    recipients_label: "Destinatarios:",
    sendtest: "Enviar prueba",
    signature: "Firma",
    subject: "Asunto",
    sender: "Remitente",
    error: "Error al enviar el correo electrónico |||| Error al enviar los correos electrónicos",
    sent_to_sib_at: "Transferido a Brevo en",
    success: "Correo(s) electrónico(s) enviado(s) con éxito",
    template: "Plantilla",
    test_error: "Error al enviar el correo de prueba",
    test_success: "Correo de prueba enviado con éxito",
    testaddress: "Dirección de correo de prueba",
    with_generated_document: "El documento generado se enviará automáticamente como adjunto.",
    invoice_document_missing:
      "Aún no existe ningún documento para %{smart_count} factura; se enviará sin adjunto. |||| Aún no existe ningún documento para %{smart_count} facturas; se enviarán sin adjunto.",
    upload_attachment: "Subir documento",
    generated_documents: "Documentos generados",
    preview: "Vista previa",
    preview_error: "Error al generar la vista previa: %{error}",
    scheduled_dispatch: "Envío programado",
    scheduled_send: "Enviar correo(s) electrónico(s)",
    day_before_event_start: "1 día antes del inicio del evento",
    day_after_event_end: "1 día después del final del evento",
    scheduled_emails: "Correo electrónico programado |||| Correos electrónicos programados",
    waiting_list_confirmation: "Enviar confirmación para lista de espera",
    contact_type: {
      invoice: "Direcciones de facturación",
      communication: "Direcciones de comunicación",
    },
    parties: {
      recipient: "Destinatario",
      attendee: "Participante",
      invoice_recipient: "Destinatario de la factura",
    },
    show_recipient_addresses:
      "Mostrar la dirección del destinatario |||| Mostrar %{smart_count} direcciones de destinatarios",
    cc_info: "Se establece un Cc para todos los correos electrónicos (no sólo para uno)",
    use_custom_email: "Indique una dirección de correo electrónico diferente",
    use_recipient_selection: "Usar la selección de destinatarios",
    total_file_size_exceeded_warning:
      "El límite de tamaño para los correos electrónicos es de 20 MB, incluidos los archivos adjuntos y el contenido del correo electrónico",
  },
  merging: {
    error: "Fusión fallida",
    merge_with: "Fusionar",
    person_to_merge: "Fusionar con",
    success: "Fusión exitosa",
    login_warning: "La persona seleccionada tiene un inicio de sesión.",
    info: {
      title: "¿Qué ocurre al fusionar?",
      deletion_and_base_data:
        "La persona seleccionada será eliminada. Los datos básicos faltantes (título, género, fecha de nacimiento, etc.) se complementarán con los del usuario a fusionar.",
      lecturer_and_attendee_data:
        "Las propiedades de participante y docente (incluidos los campos personalizados) se transfieren completamente si el usuario actual no tiene ese rol. De lo contrario, se añaden los valores faltantes.",
      contact_info_and_login:
        "El inicio de sesión solo se transfiere si la persona actual no tiene uno. La información de contacto debe transferirse manualmente si es necesario.",
      transferred_label: "Se transferirá:",
    },
  },
  invoice: {
    success: "Las facturas se han creado exitosamente",
    error: "Error al generar las facturas",
    titles: {
      correction: "Corrección de factura [%{invoiceNumber}]",
      reversal: "Anulación de factura [%{invoiceNumber}]",
      standard: "Factura",
    },
    correction_reversal: "Corrección/Anulación",
    success_delete: "La factura se eliminó exitosamente",
    error_delete: "Error al eliminar la factura",
    created_text:
      "Las siguientes facturas se han creado exitosamente y se pueden procesar con las acciones a continuación.",
    overview_text: "Las siguientes facturas se pueden procesar con las acciones a continuación.",
    send_to_accounting: "Transferir",
    selected_with_non_uniq_event: "Todas las facturas seleccionadas deben pertenecer al mismo evento",
  },
  show_detail_page: "Mostrar página de detalles",
  export: {
    error: "Exportación fallida",
    actions: {
      export: "Exportar",
      resource: "Exportar %{resource}",
      event: "Evento",
      all_attendees: "Participantes y reservas",
      all_lecturers: "Docentes",
    },
    fields: {
      days: "Días",
      all_valid_bookings_count: "Número de participantes",
    },
  },
  history: {
    action: {
      change: "modificado",
      create: "añadido",
      delete: "eliminado",
      sent: "enviado",
      sent_to: "enviado a %{to}",
    },
    boolean_change: {
      is_bookable: {
        true: "hecho reservable",
        false: "hecho no reservable",
      },
      high_priority: {
        true: "fijado",
        false: "desfijado",
      },
      is_online: {
        true: "marcado como evento en línea",
        false: "marcado como evento presencial",
      },
      is_public: {
        true: "publicado",
        false: "no publicado",
      },
    },
    special_change: "cambiado de %{oldValue} a %{newValue}",
    deleted: "eliminado",
    deleted_f: "eliminada",
    deleted_m: "eliminado",
    deleted_n: "eliminado",
    deleted_record: "No encontrado (registro probablemente eliminado): %{id}",
    fetch_error: "No se pudo cargar el historial",
    field_change: "%{name}: %{oldValue} → %{newValue}",
    value_change: "%{oldValue} → %{newValue}",
    no_value: "Sin valor",
    archived: "Archivado",
    restored: "Restaurado",
    show_all: "Mostrar historial completo",
  },
  permission_actions: {
    create: "Agregar",
    read: "Ver",
    update: "Modificar",
    delete: "Eliminar",
    update_debit_number: "Actualizar número de deudor",
  },
  feedback: {
    thank_you_headline: "Muchas gracias",
    thank_you_description:
      "Queremos agradecerle sinceramente por tomarse el tiempo para completar nuestro formulario de comentarios.",
  },
  titles: {
    event_base_child_create: "Crear oferta para %{name}",
    registration_date: "Período de inscripción",
    timespan: "Período",
  },
  actions: {
    remove_from_group: "Eliminar del grupo",
    remove_lecturer_from_event: "Eliminar del evento",
    reset_filters: "Restablecer filtros",
    select_all: "Seleccionar todo",
    show_related_data: "Mostrar contenido relacionado",
    show_all: "Mostrar todo",
    show_all_errors: "%{smart_count} error más |||| %{smart_count} errores más",
    show_less: "Mostrar menos",
    send: "Enviar",
    edit_dashboard: "Editar el cuadro de mandos",
  },
  info_page: {
    software_version: "Versión del software",
    support: "Soporte",
    support_mail: "service@priorist.com",
    release_notes: "Notas de la versión",
    release_notes_link: "https://education-manager.de/releases",
    license: "Notas de licencia",
    license_info:
      "EDM utiliza componentes y bibliotecas de terceros útiles. Agradecemos a los autores de estos productos por ponerlos a disposición del público. La siguiente sección contiene las notas de licencia requeridas para bibliotecas de terceros incluidas en EDM:",
    is_licensed_under: "está licenciado bajo",
  },
  femCount: "Una %{entity} es |||| %{count} %{entity} son",
  error: "Error",
  not: "No",
  by: "de",
  to: "a",
  at: "en",
  connected_with: "conectado con",
  disconnect: "desconectar",
  numbers: {
    2: "dos",
    3: "tres",
    4: "cuatro",
    5: "cinco",
    6: "seis",
    7: "siete",
    8: "ocho",
    9: "nueve",
    decimalSeparator: ",",
    thousandSeparator: ".",
  },
  more: "más",
  countMore: "%{count} más",
  less: "menos",
  today: "Hoy",
  tomorrow: "Mañana",
  no_data: "No hay datos disponibles",
  reports: {
    title: "Evaluación",
    sales: "Ventas",
    booking: "Reservación |||| Reservaciones",
    sold_item: "Plaza vendida |||| Plazas vendidas",
    calendar_week_with_date: "SM %{kw} desde %{date}",
    bookings_and_sales: "Plazas vendidas e ingresos",
    bookings_by_sales: "Precios de venta por ingresos",
    cancellation_by_events: "Tasa de cancelación eventos",
    event_status_chart: "Eventos por estado",
    report_by_base_data: "Datos maestros",
    total_occupancy: "Ocupación total",
    draft: "Borrador",
    offered: "Oferta",
    takes_place: "Tiene lugar",
    finished: "Completado",
    canceled: "Cancelado",
    sales_with_amount: "EUR %{amount},- Ingresos",
    best_offers: "Mejores ofertas",
    anchor: "Fecha",
    anchor_order_date: "Fecha del pedido",
    anchor_event_date: "Fecha del evento",
    date_from: "Desde",
    date_to: "Hasta",
    event_format: "Formato del evento",
    other: "Otros |||| Otro",
    states: "Análisis por estados federados",
    by_sales: "por ingresos",
    by_bookings: "por plazas vendidas",
    event_charts: "Evaluaciones",
    no_data_events: "No hay eventos disponibles en este período",
    no_data_bookings: "No hay reservas disponibles en este período",
    no_data_event_bases: "No se han reservado ofertas en este período",
    metrics: {
      cancellation: "Cancelación||||Cancelaciones",
      events_carried_out: "Evento realizado||||Eventos realizados",
      events_upcoming: "Próximo evento||||Próximos eventos",
      average_price: "Precio promedio",
      wating_ratio: "Tasa de lista de espera",
    },
  },
  dashboard: {
    title: "Tablero",
    no_data_bookings: "No hay reservas disponibles",
    bookings_overview: "Reservas actuales",
    bookings_by_type: "Resumen de participación",
    longest_waitinglist: "Lista de espera más larga",
    registration_period_exceeded: "Período de inscripción alcanzado",
    booked_out: "Agotado",
    show_own: "Solo mis",
    empty_timeline: "No hay actividades disponibles",
    still_billable: "Aún por facturar",
    amount_open: "Abierto",
    amount_total: "Cantidad total",
    few_bookings_necessary: "Solo se necesitan unas pocas reservas más",
    takes_place: "tiene lugar",
    upcoming_events: "Próximos eventos",
    timespan: "Período",
    in_room: "en sala %{room}",
    more_lecturers: "... %{count} más",
    less_lecturers: "... menos",
    valid: "Registrado",
    waiting: "Lista de espera",
    canceled: "Cancelado",
    search_event: "Buscar evento",
    recent_edited: "Última edición",
    recent_orders: "Pedidos recientes",
    filter: {
      today: "Hoy",
      yesterday: "Ayer",
      next_seven_days: "Próximos 7 días",
      next_thirty_days: "Próximos 30 días",
      next_three_months: "Próximos 3 meses",
      last_seven_days: "Últimos 7 días",
      last_thirty_days: "Últimos 30 días",
      current_month: "Mes actual",
      custom_range: "Intervalo personalizado",
      last_three_months: "Últimos 3 meses",
      last_six_months: "Últimos 6 meses",
      this_year: "Este año",
      last_year: "Año pasado",
      penultimate_year: "Antepenúltimo año",
      remaining_year: "Resto del año",
    },
  },
  event_formats: {
    ONLINE: "En línea",
    ONSITE: "Presencial",
    HYBRID: "Híbrido",
    E_LEARNING: "E-Learning",
  },
  attendance_formats: {
    ONLINE: "En línea",
    ONSITE: "Presencial",
    HYBRID: "Híbrido",
  },
  email_scope_description: {
    NEW_MOODLE_ACCOUNT_TEMPLATE:
      "Se usa automáticamente cuando se vincula una persona a una cuenta de Moodle y se crea una nueva cuenta. Solo se puede asignar una plantilla para este ámbito.",
    ENROLLMENT_APPROVAL_TEMPLATE:
      "Se usa automáticamente cuando una inscripción necesita ser aprobada por una persona responsable. Solo se puede asignar una plantilla para este ámbito.",
    ENROLLMENT_DENIED_TEMPLATE:
      "Se usa automáticamente cuando una inscripción es rechazada por una persona responsable. Solo se puede asignar una plantilla para este ámbito.",
    BOOKING_TEMPLATES: "Plantillas que se usan en el contexto de reservas.",
    BOOKING_CONFIRMATION_TEMPLATES:
      "Plantillas para confirmar una reserva exitosa, por ejemplo, al procesar una inscripción.",
    LECTURER_TEMPLATES: "Plantillas utilizadas para la comunicación con docentes.",
    CONSENT_TEMPLATES:
      "Plantillas usadas en procesos de consentimiento, como un doble opt-in para obtener o confirmar autorizaciones, por ejemplo para el acceso al portal.",
    ENROLLMENT_CONFIRMATION_TEMPLATE:
      "Se envía automáticamente después de una inscripción exitosa (por ejemplo, mediante el sitio web) a un evento. Solo se puede asignar una plantilla para este ámbito.",
    FEEDBACK_TEMPLATES: "Plantillas utilizadas para enviar encuestas de opinión.",
    NEW_ATTENDEE_TEMPLATE:
      "Se usa automáticamente cuando se asigna un acceso a una persona o docente mediante la interfaz EDM. Solo se puede asignar una plantilla para este ámbito.",
    NEW_STAFF_MEMBER_TEMPLATE:
      "Se usa automáticamente cuando se asigna un acceso a un miembro del personal mediante la interfaz EDM. Solo se puede asignar una plantilla para este ámbito.",
    ATTENDEE_TEMPLATES:
      "Plantillas utilizadas para comunicarse con personas. Importante: no aparecen en el contexto de reservas, sino solo en el contexto de personas.",
    LECTURER_BOOKING_TEMPLATES:
      "Plantillas disponibles en el portal de docentes para comunicarse con los participantes.",
    INVOICE_TEMPLATES: "Plantillas utilizadas en el contexto de facturación.",
    PASSWORD_RESET_TEMPLATE:
      "Se usa automáticamente para enviar un enlace de restablecimiento de contraseña. Solo se puede asignar una plantilla para este ámbito.",
    ATTENDANCE_CONFIRMATION_TEMPLATES: "Plantillas utilizadas para enviar confirmaciones de asistencia.",
    WAITING_LIST_TEMPLATES:
      "Plantillas utilizadas para confirmar una reserva en la lista de espera, por ejemplo al procesar una inscripción.",
    ORDER_CONFIRMATION_TEMPLATE:
      "Se envía automáticamente al comprador cuando se recibe un pedido. Solo se puede asignar una plantilla a este ámbito.",
    ORDER_ITEM_APPROVAL_TEMPLATE:
      "Se envía automáticamente para solicitar la aprobación externa de una posición del pedido. Solo se puede asignar una plantilla a este ámbito.",
    ORDER_ITEM_DENIED_TEMPLATE:
      "Se envía automáticamente cuando se rechaza la aprobación de una posición del pedido. Solo se puede asignar una plantilla a este ámbito.",
    ORDER_TEMPLATES:
      "Plantillas utilizadas en el contexto de pedidos, p. ej. para correos a la persona u organización que realiza el pedido.",
    ORGANIZATION_TEMPLATES: "Plantillas utilizadas para comunicarse con organizaciones.",
    USER_TEMPLATES:
      "Plantillas utilizadas para comunicarse con personas. El rol de participante y sus campos personalizados no están disponibles aquí; para ello, utilice el ámbito de participantes.",
    BOOKING_CANCELLATION_REQUEST:
      "Se envía automáticamente al correo de contacto de cancelación de la configuración cuando una persona solicita una cancelación en el portal. Sin esta plantilla no es posible solicitar cancelaciones. Solo se puede asignar una plantilla a este ámbito.",
    BOOKING_CANCELLATION_RECEIVED:
      "Se envía automáticamente a la persona que solicitó una cancelación para confirmar la recepción de la solicitud. Solo se puede asignar una plantilla a este ámbito.",
    EVENT_LOCATION_TEMPLATES:
      "Plantillas que se pueden usar para comunicarse con los lugares del evento. Los correos se envían a la dirección de correo del lugar.",
    INTEREST_TEMPLATES:
      "Plantillas para comunicarse con personas interesadas en una oferta o un evento. No se envía ningún correo automáticamente al recibir un interés.",
  },
  permissions_description: {
    default:
      "Panel (sin aún por facturar) / Ver eventos incl. reservas / Ver ofertas / Ver participantes / Ver interesados / Ver docentes / Exportar registros / Ver notas / Ver historial",
    manage_events:
      "Crear, editar y archivar eventos / Crear, editar y eliminar fechas de eventos / Crear, editar y eliminar precios de eventos / Crear, editar y eliminar documentos de eventos / Crear, editar y eliminar notas de eventos / Funciones de eventos (por ejemplo, cambiar estado, duplicar, asignar grupo, cambiar oferta)",
    manage_event_bases:
      "Crear, editar y archivar ofertas / Crear, editar y eliminar descripciones de ofertas / Crear, editar y eliminar documentos de ofertas / Crear, editar y eliminar notas de ofertas / Funciones de ofertas (por ejemplo, cambiar tipo de oferta, duplicar)",
    manage_orders:
      "Crear, confirmar, cancelar y procesar pedidos / Reservar y asignar posiciones de pedido / Crear facturas de pedidos / Envío de correo electrónico",
    manage_users:
      "Crear, editar y archivar personas / Crear, editar y eliminar datos de contacto / Crear, editar y eliminar etiquetas",
    manage_attendees:
      "Crear, editar y archivar participantes / Crear, editar y eliminar datos de contacto de participantes / Crear, editar y eliminar documentos de participantes / Crear, editar y eliminar notas de participantes / Funciones de participantes (por ejemplo, fusionar, crear inicio de sesión) / Envío de correo electrónico",
    manage_interests: "Crear, editar y eliminar interesados",
    manage_lecturers:
      "Crear, editar y archivar docentes / Crear, editar y eliminar datos de contacto de docentes / Crear, editar y eliminar documentos de docentes / Crear, editar y eliminar notas de docentes / Funciones de docentes (por ejemplo, fusionar, crear inicio de sesión) / Envío de correo electrónico",
    manage_todos_and_responsibilities:
      "Crear, editar y eliminar tareas dentro de un evento / Crear, editar y eliminar responsabilidades dentro de un evento",
    manage_moodle:
      "Enlazar, crear y eliminar cursos de Moodle / Enlazar, crear y eliminar cuentas de Moodle / Crear y eliminar inscripciones de Moodle",
    manage_bookings:
      "Crear, editar y eliminar reservas / Crear, editar y eliminar documentos de reservas / Ver facturas / Envío de correo electrónico",
    manage_invoices:
      'Crear, editar y eliminar facturas (incl. corrección y cancelación) / Enviar facturas / Mostrar "aún por facturar" en el panel',
    view_accounting: "Ver facturación EDM",
    view_reporting: "Ver informes",
    view_booking_list: "Ver lista de reservas",
    view_invoice_list: "Ver lista de facturas",
    manage_accounting:
      "Transferir facturas (p. ej. a ScopeVisio) / Ver y editar número de deudor de participantes y campos de cuenta de eventos / Marcar reservas como pagadas",
    manage_access:
      "Crear, editar y archivar empleados / Crear, editar y eliminar grupos de permisos / Crear, editar y eliminar aplicaciones OAuth",
    manage_templates:
      "Crear, editar y eliminar plantillas de correo electrónico / Crear, editar y eliminar remitentes de correo electrónico / Crear, editar y eliminar plantillas de documentos / Crear, editar y eliminar responsabilidades / Crear, editar y eliminar campos avanzados / Crear, editar y eliminar listas de tareas",
    manage_settings:
      "Editar configuraciones generales / Crear, editar y eliminar tipos de precios / Crear, editar y eliminar entornos / Crear, editar y eliminar tipos de ofertas / Activar y desactivar aplicaciones vinculadas",
    manage_base_data:
      "Crear, editar y eliminar lugares de eventos / Crear, editar y eliminar socios cooperativos / Crear, editar y eliminar grupos objetivo / Crear, editar y eliminar categorías / Crear, editar y eliminar palabras clave",
    manage_organizations: "Crear, editar y eliminar organizaciones. Agregar personas a organizaciones",
    manage_event_feedback:
      "Guardar cuestionario de feedback para el evento / Ver evaluación de feedback específica del evento",
    view_feedback_report: "Ver evaluación general de feedback",
  },
  portal: {
    welcome: "¡Bienvenido!",
    logged_in_as: "Has iniciado sesión como",
    your_bookings: "Tus reservas",
    your_orders: "Sus pedidos",
    your_open_orders: "Pedidos abiertos",
    your_interests: "Sus favoritos personales",
    your_events: "Tus eventos",
    your_organizations: "Sus organizaciones",
    create_organization: "Crear organización",
    no_organizations: "Todavía no hay ninguna organización asignada.",
    show_past_bookings: "Reservas pasadas",
    show_past_events: "Eventos pasados",
    event_canceled: "Este evento fue cancelado",
    booking_waitinglist: "Estás en la lista de espera",
    booking_canceled: "Esta reserva fue cancelada",
    missing_consent:
      "Tenga en cuenta que aún no ha confirmado su dirección de correo electrónico. Solo después de la confirmación podrá utilizar las funciones del portal. Si no ha recibido un correo de verificación o necesita uno nuevo, utilice el botón de abajo.",
    confirm_your_email: "Por favor confirme su dirección de correo electrónico",
    resend_verification_mail: "Reenviar correo de confirmación",
  },
  languages: {
    de: "Alemán",
    en: "Inglés",
    fr: "Francés",
    es: "Español",
  },
  admin: {
    descriptions: {
      event_locations: "Gestionar lugares y salas",
      partners: "Mantener datos de socios con descripciones",
      audiences: "Definir grupos objetivo para las ofertas",
      categories: "Estructurar y gestionar categorías temáticas",
      tags: "Crear etiquetas para búsqueda y filtrado",
      user_lists: "Gestionar y mantener listas de personas y contactos",

      staff_members: "Administrar cuentas y gestionar permisos",
      user_roles: "Definir y asignar derechos de acceso",
      o_auth_apps: "Registrar apps externas y gestionar tokens",
      subscriptions: "Gestionar webhooks para diferentes eventos",

      email_senders: "Configurar perfiles de remitente y firmas",
      external_email_templates: "Diseñar y versionar correos estándar",
      custom_field_content_types: "Modelar atributos personalizados",
      responsibility_types: "Asignar responsables por tipo de oferta",
      todo_lists: "Crear listas de tareas y definir plantillas",
      document_templates: "Subir diseños de Office y definir marcadores",
      invoice_templates: "Configurar diseño incl. factura electrónica",
      feedback_forms: "Diseñar y gestionar cuestionarios",

      settings: "Ajustar parámetros globales y branding",
      event_types: "Definir tipos con campos de descripción",
      customer_invoices: "Consultar la facturación de uso de Education Manager",
      customer: "Configurar datos de organización y contacto",
      price_types: "Gestionar variantes de precios y descuentos",
      contexts: "Delimitar sus ofertas educativas",
      tax_rates: "Gestionar tasas impositivas",
      integrated_applications: "Ver integraciones",
      consent_types: "Gestionar categorías de consentimiento según RGPD",
      settings_general: "Configurar parámetros generales, enlaces y ajustes de correo",
      settings_portal: "Configurar el portal de participantes y el acceso de formadores",
      settings_defaults: "Definir valores predeterminados para nuevos eventos",
      settings_storefront: "Personalizar la configuración del storefront",
      settings_orders: "Configurar las validaciones de pedidos, el comportamiento del pago y la facturación",
    },
  },
  mdx: {
    dialogControls: {
      save: "Enregistrer",
      cancel: "Annuler",
    },
    createLink: {
      url: "URL",
      urlPlaceholder: "Sélectionner ou coller une URL",
      title: "Titre",
      saveTooltip: "Définir l'URL",
      cancelTooltip: "Annuler les modifications",
    },
    linkPreview: {
      open: "Ouvrir {{url}} dans une nouvelle fenêtre",
      edit: "Modifier l'URL du lien",
      copyToClipboard: "Copier dans le presse-papiers",
      copied: "Copié !",
      remove: "Supprimer le lien",
    },
    toolbar: {
      blockTypes: {
        paragraph: "Paragraphe",
        quote: "Citation",
        heading: "Titre {{level}}",
      },
      blockTypeSelect: {
        selectBlockTypeTooltip: "Sélectionner un type de bloc",
        placeholder: "Type de bloc",
      },
      toggleGroup: "Groupe à bascule",
      removeBold: "Retirer le gras",
      bold: "Gras",
      removeItalic: "Retirer l'italique",
      italic: "Italique",
      underline: "Souligné",
      removeUnderline: "Retirer le soulignement",
      removeInlineCode: "Retirer le format code",
      inlineCode: "Code en ligne",
      link: "Créer un lien",
      richText: "Texte enrichi",
      diffMode: "Mode de comparaison",
      source: "Mode source",
      admonition: "Insérer une admonition",
      codeBlock: "Insérer un bloc de code",
      editFrontmatter: "Modifier les métadonnées",
      insertFrontmatter: "Insérer les métadonnées",
      image: "Insérer une image",
      insertSandpack: "Insérer un Sandpack",
      table: "Insérer un tableau",
      thematicBreak: "Insérer une séparation thématique",
      bulletedList: "Liste à puces",
      numberedList: "Liste numérotée",
      checkList: "Liste de tâches",
      deleteSandpack: "Supprimer ce bloc de code",
      undo: "Annuler {{shortcut}}",
      redo: "Rétablir {{shortcut}}",
      highlight: "Surligner",
      removeHighlight: "Supprimer le surlignage",
    },
    contentArea: {
      editableMarkdown: "Markdown modifiable",
    },
    parseError: "Error al analizar el contenido markdown. El contenido puede contener formato no válido.",
  },
  event_date_planner: {
    series_toggle: "Añadir serie de fechas",
    time_toggle: "Especificar hora",
    details_toggle: "Detalles adicionales",
    no_existing_dates: "No hay fechas disponibles",
    existing_dates: "Mostrar fecha |||| Mostrar %{smart_count} fechas",
    add_dates: "Añadir fechas",
    already_planned:
      "%{smart_count} día ya tiene una fecha y se omitió: %{days} |||| %{smart_count} días ya tienen una fecha y se omitieron: %{days}",
    save_planned_dates: "Guardar",
    remove_all_dates: "Quitar todas las fechas",
    planned_dates: "Añadir %{smart_count} fecha |||| Añadir %{smart_count} fechas",
    every: "cada",
    weeks: "semana(s)",
    months: "mes(es)",
    days: "día(s)",
    years: "año(s)",
    weekly: "Semanal",
    monthly: "Mensual",
    daily: "Diario",
    on: "Hasta el",
    after: "Después de x veces",
    single_date: "Fechas individuales",
    rrule: {
      name: "Fechas recurrentes",
      interval: "Intervalo",
      start: "Inicio",
      frequency: "Frecuencia",
      end_condition: "Termina",
      end_date: "Fecha de fin",
      end_count: "Repeticiones",
    },
    weekdays: {
      monday: "Lun",
      tuesday: "Mar",
      wednesday: "Mié",
      thursday: "Jue",
      friday: "Vie",
      saturday: "Sáb",
      sunday: "Dom",
    },
  },
};

export default spanishMessages;
